/* eslint-disable */

import CircleCrossFilledMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_filled_m.svg"
import CircleCrossFilledSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_filled_s.svg"
import CircleCrossFilledExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_filled_xs.svg"
import CircleCrossLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_l.svg"
import CircleCrossMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_m.svg"
import CircleCrossSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_s.svg"
import CircleCrossExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_xl.svg"
import CircleCrossExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_cross_xs.svg"
import CircleMinusLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_minus_l.svg"
import CircleMinusMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_minus_m.svg"
import CircleMinusSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_minus_s.svg"
import CircleMinusExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_minus_xl.svg"
import CircleMinusExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_minus_xs.svg"
import CirclePlusFilledMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_filled_m.svg"
import CirclePlusFilledSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_filled_s.svg"
import CirclePlusFilledExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_filled_xs.svg"
import CirclePlusLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_l.svg"
import CirclePlusMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_m.svg"
import CirclePlusSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_s.svg"
import CirclePlusExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_xl.svg"
import CirclePlusExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_plus_xs.svg"
import CircleTickFilledMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_filled_m.svg"
import CircleTickFilledSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_filled_s.svg"
import CircleTickFilledExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_filled_xs.svg"
import CircleTickLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_l.svg"
import CircleTickMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_m.svg"
import CircleTickOpenLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_open_l.svg"
import CircleTickOpenMedium from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_open_m.svg"
import CircleTickOpenSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_open_s.svg"
import CircleTickOpenExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_open_xl.svg"
import CircleTickOpenExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_open_xs.svg"
import CircleTickSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_s.svg"
import CircleTickExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_xl.svg"
import CircleTickExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_circle_tick_xs.svg"
import ClockLarge from "../submodules/otto-icons/originalIcons/Circles/icon_clock_l.svg"
import ClockMedium from "../submodules/otto-icons/originalIcons/Circles/icon_clock_m.svg"
import ClockSmall from "../submodules/otto-icons/originalIcons/Circles/icon_clock_s.svg"
import ClockExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_clock_xl.svg"
import CompassLarge from "../submodules/otto-icons/originalIcons/Circles/icon_compass_l.svg"
import CompassMedium from "../submodules/otto-icons/originalIcons/Circles/icon_compass_m.svg"
import CompassSmall from "../submodules/otto-icons/originalIcons/Circles/icon_compass_s.svg"
import CompassExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_compass_xl.svg"
import DeadLarge from "../submodules/otto-icons/originalIcons/Circles/icon_dead_l.svg"
import DeadMedium from "../submodules/otto-icons/originalIcons/Circles/icon_dead_m.svg"
import DeadSmall from "../submodules/otto-icons/originalIcons/Circles/icon_dead_s.svg"
import DeadExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_dead_xl.svg"
import DeniedLarge from "../submodules/otto-icons/originalIcons/Circles/icon_denied_l.svg"
import DeniedMedium from "../submodules/otto-icons/originalIcons/Circles/icon_denied_m.svg"
import DeniedSmall from "../submodules/otto-icons/originalIcons/Circles/icon_denied_s.svg"
import DeniedExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_denied_xl.svg"
import DeniedExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_denied_xs.svg"
import HappyLarge from "../submodules/otto-icons/originalIcons/Circles/icon_happy_l.svg"
import HappyMedium from "../submodules/otto-icons/originalIcons/Circles/icon_happy_m.svg"
import HappySmall from "../submodules/otto-icons/originalIcons/Circles/icon_happy_s.svg"
import HappyExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_happy_xl.svg"
import HelpFilledMedium from "../submodules/otto-icons/originalIcons/Circles/icon_help_filled_m.svg"
import HelpFilledSmall from "../submodules/otto-icons/originalIcons/Circles/icon_help_filled_s.svg"
import HelpFilledExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_help_filled_xs.svg"
import HelpLarge from "../submodules/otto-icons/originalIcons/Circles/icon_help_l.svg"
import HelpMedium from "../submodules/otto-icons/originalIcons/Circles/icon_help_m.svg"
import HelpSmall from "../submodules/otto-icons/originalIcons/Circles/icon_help_s.svg"
import HelpExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_help_xl.svg"
import HelpExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_help_xs.svg"
import HumbleFailLarge from "../submodules/otto-icons/originalIcons/Circles/icon_humble_fail_l.svg"
import HumbleFailMedium from "../submodules/otto-icons/originalIcons/Circles/icon_humble_fail_m.svg"
import HumbleFailSmall from "../submodules/otto-icons/originalIcons/Circles/icon_humble_fail_s.svg"
import HumbleFailExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_humble_fail_xl.svg"
import InfoFilledMedium from "../submodules/otto-icons/originalIcons/Circles/icon_info_filled_m.svg"
import InfoFilledSmall from "../submodules/otto-icons/originalIcons/Circles/icon_info_filled_s.svg"
import InfoFilledExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_info_filled_xs.svg"
import InfoLarge from "../submodules/otto-icons/originalIcons/Circles/icon_info_l.svg"
import InfoMedium from "../submodules/otto-icons/originalIcons/Circles/icon_info_m.svg"
import InfoSmall from "../submodules/otto-icons/originalIcons/Circles/icon_info_s.svg"
import InfoExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_info_xl.svg"
import InfoExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_info_xs.svg"
import SadLarge from "../submodules/otto-icons/originalIcons/Circles/icon_sad_l.svg"
import SadMedium from "../submodules/otto-icons/originalIcons/Circles/icon_sad_m.svg"
import SadSmall from "../submodules/otto-icons/originalIcons/Circles/icon_sad_s.svg"
import SadExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_sad_xl.svg"
import VeryHappyLarge from "../submodules/otto-icons/originalIcons/Circles/icon_very_happy_l.svg"
import VeryHappyMedium from "../submodules/otto-icons/originalIcons/Circles/icon_very_happy_m.svg"
import VeryHappySmall from "../submodules/otto-icons/originalIcons/Circles/icon_very_happy_s.svg"
import VeryHappyExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_very_happy_xl.svg"
import WarningFilledMedium from "../submodules/otto-icons/originalIcons/Circles/icon_warning_filled_m.svg"
import WarningFilledSmall from "../submodules/otto-icons/originalIcons/Circles/icon_warning_filled_s.svg"
import WarningFilledExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_warning_filled_xs.svg"
import WarningLarge from "../submodules/otto-icons/originalIcons/Circles/icon_warning_l.svg"
import WarningMedium from "../submodules/otto-icons/originalIcons/Circles/icon_warning_m.svg"
import WarningSmall from "../submodules/otto-icons/originalIcons/Circles/icon_warning_s.svg"
import WarningExtraLarge from "../submodules/otto-icons/originalIcons/Circles/icon_warning_xl.svg"
import WarningExtraSmall from "../submodules/otto-icons/originalIcons/Circles/icon_warning_xs.svg"
import BarZeroOneLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_01_l.svg"
import BarZeroOneMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_01_m.svg"
import BarZeroOneSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_01_s.svg"
import BarZeroTwoLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_02_l.svg"
import BarZeroTwoMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_02_m.svg"
import BarZeroTwoSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_02_s.svg"
import BarZeroThreeLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_03_l.svg"
import BarZeroThreeMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_03_m.svg"
import BarZeroThreeSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_bar_03_s.svg"
import BycicleLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_bycicle_l.svg"
import BycicleMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_bycicle_m.svg"
import BycicleSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_bycicle_s.svg"
import CookingLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_cooking_l.svg"
import CookingMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_cooking_m.svg"
import CookingSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_cooking_s.svg"
import CutleryZeroOneLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_01_l.svg"
import CutleryZeroOneMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_01_m.svg"
import CutleryZeroOneSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_01_s.svg"
import CutleryZeroTwoLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_02_l.svg"
import CutleryZeroTwoMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_02_m.svg"
import CutleryZeroTwoSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_02_s.svg"
import CutleryZeroThreeLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_03_l.svg"
import CutleryZeroThreeMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_03_m.svg"
import CutleryZeroThreeSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_cutlery_03_s.svg"
import DeliveryBagLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_delivery_bag_l.svg"
import DeliveryBagMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_delivery_bag_m.svg"
import DeliveryBagSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_delivery_bag_s.svg"
import KitchenbellLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_kitchenbell_l.svg"
import KitchenbellMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_kitchenbell_m.svg"
import KitchenbellSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_kitchenbell_s.svg"
import PrepFoodLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_prep_food_l.svg"
import PrepFoodMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_prep_food_m.svg"
import PrepFoodSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_prep_food_s.svg"
import StopwatchLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_stopwatch_l.svg"
import StopwatchMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_stopwatch_m.svg"
import StopwatchSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_stopwatch_s.svg"
import TableLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_table_l.svg"
import TableMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_table_m.svg"
import TableNumberLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_table_number_l.svg"
import TableNumberMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_table_number_m.svg"
import TableNumberSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_table_number_s.svg"
import TableSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_table_s.svg"
import TimerLarge from "../submodules/otto-icons/originalIcons/Food and drink/icon_timer_l.svg"
import TimerMedium from "../submodules/otto-icons/originalIcons/Food and drink/icon_timer_m.svg"
import TimerSmall from "../submodules/otto-icons/originalIcons/Food and drink/icon_timer_s.svg"
import BatteryChargingLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_charging_l.svg"
import BatteryChargingMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_charging_m.svg"
import BatteryChargingSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_charging_s.svg"
import BatteryChargingExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_charging_xl.svg"
import BatteryChargingExtraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_charging_xs.svg"
import BatteryCriticalLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_critical_l.svg"
import BatteryCriticalMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_critical_m.svg"
import BatteryCriticalSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_critical_s.svg"
import BatteryCriticalExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_critical_xl.svg"
import BatteryCriticalExtraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_critical_xs.svg"
import BatteryEmptyLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_empty_l.svg"
import BatteryEmptyMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_empty_m.svg"
import BatteryEmptySmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_empty_s.svg"
import BatteryEmptyExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_empty_xl.svg"
import BatteryEmptyExtraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_empty_xs.svg"
import BatteryOneBarLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_one_bar_l.svg"
import BatteryOneBarMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_one_bar_m.svg"
import BatteryOneBarSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_one_bar_s.svg"
import BatteryOneBarExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_one_bar_xl.svg"
import BatteryOneBarExtraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_one_bar_xs.svg"
import BatteryThreeBarsLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_three_bars_l.svg"
import BatteryThreeBarsMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_three_bars_m.svg"
import BatteryThreeBarsSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_three_bars_s.svg"
import BatteryThreeBarsExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_three_bars_xl.svg"
import BatteryThreeBarsExtraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_three_bars_xs.svg"
import BatteryTwoBarsLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_two_bars_l.svg"
import BatteryTwoBarsMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_two_bars_m.svg"
import BatteryTwoBarsSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_two_bars_s.svg"
import BatteryTwoBarsExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_two_bars_xl.svg"
import BatteryTwoBarsExtraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_battery_two_bars_xs.svg"
import CameraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_camera_l.svg"
import CameraMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_camera_m.svg"
import CameraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_camera_s.svg"
import CameraExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_camera_xl.svg"
import CameraExtraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_camera_xs.svg"
import CardReaderOneDisconnectedLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_disconnected_l.svg"
import CardReaderOneDisconnectedMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_disconnected_m.svg"
import CardReaderOneDisconnectedSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_disconnected_s.svg"
import CardReaderOneDisconnectedExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_disconnected_xl.svg"
import CardReaderOneLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_l.svg"
import CardReaderOneMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_m.svg"
import CardReaderOneSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_s.svg"
import CardReaderOneExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_card_reader_one_xl.svg"
import CashDrawerFilledMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_cash_drawer_filled_m.svg"
import CashDrawerFilledSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_cash_drawer_filled_s.svg"
import CashDrawerLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_cash_drawer_l.svg"
import CashDrawerMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_cash_drawer_m.svg"
import CashDrawerSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_cash_drawer_s.svg"
import CashDrawerExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_cash_drawer_xl.svg"
import HeadphonesLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_headphones_l.svg"
import HeadphonesMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_headphones_m.svg"
import HeadphonesSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_headphones_s.svg"
import HeadphonesExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_headphones_xl.svg"
import LaptopLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_laptop_l.svg"
import LaptopMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_laptop_m.svg"
import LaptopSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_laptop_s.svg"
import LaptopExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_laptop_xl.svg"
import MicrophoneLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_microphone_l.svg"
import MicrophoneMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_microphone_m.svg"
import MicrophoneSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_microphone_s.svg"
import MicrophoneExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_microphone_xl.svg"
import MiuraDisconnectedLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_disconnected_l.svg"
import MiuraDisconnectedMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_disconnected_m.svg"
import MiuraDisconnectedSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_disconnected_s.svg"
import MiuraDisconnectedExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_disconnected_xl.svg"
import MiuraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_l.svg"
import MiuraMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_m.svg"
import MiuraSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_s.svg"
import MiuraExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_miura_xl.svg"
import PeripheralsLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_peripherals_l.svg"
import PeripheralsMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_peripherals_m.svg"
import PeripheralsSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_peripherals_s.svg"
import PeripheralsExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_peripherals_xl.svg"
import PhoneLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_phone_l.svg"
import PhoneMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_phone_m.svg"
import PhoneSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_phone_s.svg"
import PhoneExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_phone_xl.svg"
import PrinterBatteryOnebarMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_printer_battery_1bar_m.svg"
import PrinterBatteryTwobarsMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_printer_battery_2bars_m.svg"
import PrinterBatteryThreebarsMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_printer_battery_3bars_m.svg"
import PrinterBatteryChargingMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_printer_battery_charging_m.svg"
import PrinterBatteryCriticalMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_printer_battery_critical_m.svg"
import ReceiptPrinterFilledMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_receipt_printer_filled_m.svg"
import ReceiptPrinterFilledSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_receipt_printer_filled_s.svg"
import ReceiptPrinterLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_receipt_printer_l.svg"
import ReceiptPrinterMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_receipt_printer_m.svg"
import ReceiptPrinterSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_receipt_printer_s.svg"
import ReceiptPrinterExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_receipt_printer_xl.svg"
import StandardPrinterFilledMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_standard_printer_filled_m.svg"
import StandardPrinterFilledSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_standard_printer_filled_s.svg"
import StandardPrinterLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_standard_printer_l.svg"
import StandardPrinterMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_standard_printer_m.svg"
import StandardPrinterSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_standard_printer_s.svg"
import StandardPrinterExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_standard_printer_xl.svg"
import TabletLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_tablet_l.svg"
import TabletMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_tablet_m.svg"
import TabletSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_tablet_s.svg"
import TabletExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_tablet_xl.svg"
import TerminalDockMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_terminal_dock_m.svg"
import TerminalMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_terminal_m.svg"
import UsbCableLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_usb_cable_l.svg"
import UsbCableMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_usb_cable_m.svg"
import UsbCableSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_usb_cable_s.svg"
import UsbCableExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_usb_cable_xl.svg"
import WifiDisabledLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_disabled_l.svg"
import WifiDisabledMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_disabled_m.svg"
import WifiDisabledSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_disabled_s.svg"
import WifiDisabledExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_disabled_xl.svg"
import WifiLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_l.svg"
import WifiMedium from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_m.svg"
import WifiSmall from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_s.svg"
import WifiExtraLarge from "../submodules/otto-icons/originalIcons/Hardware/icon_wifi_xl.svg"
import AlipayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_alipay_m.svg"
import AmexMedium from "../submodules/otto-icons/originalIcons/Logos/icon_amex_m.svg"
import AndroidMedium from "../submodules/otto-icons/originalIcons/Logos/icon_android_m.svg"
import AndroidPayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_android_pay_m.svg"
import AppleMedium from "../submodules/otto-icons/originalIcons/Logos/icon_apple_m.svg"
import ApplePayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_apple_pay_m.svg"
import BluetoothMedium from "../submodules/otto-icons/originalIcons/Logos/icon_bluetooth_m.svg"
import CarnetMedium from "../submodules/otto-icons/originalIcons/Logos/icon_carnet_m.svg"
import CartebleueMedium from "../submodules/otto-icons/originalIcons/Logos/icon_cartebleue_m.svg"
import ContactlessMedium from "../submodules/otto-icons/originalIcons/Logos/icon_contactless_m.svg"
import DinersMedium from "../submodules/otto-icons/originalIcons/Logos/icon_diners_m.svg"
import DiscoverMedium from "../submodules/otto-icons/originalIcons/Logos/icon_discover_m.svg"
import EcMedium from "../submodules/otto-icons/originalIcons/Logos/icon_ec_m.svg"
import ElectronMedium from "../submodules/otto-icons/originalIcons/Logos/icon_electron_m.svg"
import EloMedium from "../submodules/otto-icons/originalIcons/Logos/icon_elo_m.svg"
import ElvMedium from "../submodules/otto-icons/originalIcons/Logos/icon_elv_m.svg"
import GpayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_gpay_m.svg"
import HiperMedium from "../submodules/otto-icons/originalIcons/Logos/icon_hiper_m.svg"
import HipercardMedium from "../submodules/otto-icons/originalIcons/Logos/icon_hipercard_m.svg"
import JcbMedium from "../submodules/otto-icons/originalIcons/Logos/icon_jcb_m.svg"
import KlarnaMedium from "../submodules/otto-icons/originalIcons/Logos/icon_klarna_m.svg"
import MaestroMedium from "../submodules/otto-icons/originalIcons/Logos/icon_maestro_m.svg"
import MastercardFullMedium from "../submodules/otto-icons/originalIcons/Logos/icon_mastercard_full_m.svg"
import MastercardMedium from "../submodules/otto-icons/originalIcons/Logos/icon_mastercard_m.svg"
import MobilepayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_mobilepay_m.svg"
import NfcMedium from "../submodules/otto-icons/originalIcons/Logos/icon_nfc_m.svg"
import PaypalMedium from "../submodules/otto-icons/originalIcons/Logos/icon_paypal_m.svg"
import SamsungPayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_samsung_pay_m.svg"
import SkatterverketMedium from "../submodules/otto-icons/originalIcons/Logos/icon_skatterverket_m.svg"
import SwishMedium from "../submodules/otto-icons/originalIcons/Logos/icon_swish_m.svg"
import UnionpayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_unionpay_m.svg"
import VenmoMedium from "../submodules/otto-icons/originalIcons/Logos/icon_venmo_m.svg"
import VippsMedium from "../submodules/otto-icons/originalIcons/Logos/icon_vipps_m.svg"
import VisaMedium from "../submodules/otto-icons/originalIcons/Logos/icon_visa_m.svg"
import VpayMedium from "../submodules/otto-icons/originalIcons/Logos/icon_vpay_m.svg"
import WechatMedium from "../submodules/otto-icons/originalIcons/Logos/icon_wechat_m.svg"
import ZettleIconMedium from "../submodules/otto-icons/originalIcons/Logos/icon_zettle_icon_m.svg"
import ZettleMedium from "../submodules/otto-icons/originalIcons/Logos/icon_zettle_m.svg"
import ZettleNegativeMedium from "../submodules/otto-icons/originalIcons/Logos/icon_zettle_negative_m.svg"
import ZettleZMedium from "../submodules/otto-icons/originalIcons/Logos/icon_zettle_z_m.svg"
import ArrowDownLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_down_l.svg"
import ArrowDownMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_down_m.svg"
import ArrowDownSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_down_s.svg"
import ArrowDownExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_down_xl.svg"
import ArrowDownExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_down_xs.svg"
import ArrowLeftLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_left_l.svg"
import ArrowLeftMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_left_m.svg"
import ArrowLeftSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_left_s.svg"
import ArrowLeftExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_left_xl.svg"
import ArrowLeftExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_left_xs.svg"
import ArrowRightLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_right_l.svg"
import ArrowRightMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_right_m.svg"
import ArrowRightSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_right_s.svg"
import ArrowRightExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_right_xl.svg"
import ArrowRightExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_right_xs.svg"
import ArrowUpLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_up_l.svg"
import ArrowUpMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_up_m.svg"
import ArrowUpSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_up_s.svg"
import ArrowUpExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_up_xl.svg"
import ArrowUpExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_arrow_up_xs.svg"
import BarDiagramLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_bar_diagram_l.svg"
import BarDiagramMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_bar_diagram_m.svg"
import BarDiagramSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_bar_diagram_s.svg"
import BarDiagramExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_bar_diagram_xl.svg"
import CrossLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_cross_l.svg"
import CrossMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_cross_m.svg"
import CrossSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_cross_s.svg"
import CrossExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_cross_xl.svg"
import CrossExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_cross_xs.svg"
import DownloadLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_download_l.svg"
import DownloadMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_download_m.svg"
import DownloadSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_download_s.svg"
import DownloadExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_download_xl.svg"
import ExportLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_export_l.svg"
import ExportMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_export_m.svg"
import ExportSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_export_s.svg"
import ExportExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_export_xl.svg"
import ImportLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_import_l.svg"
import ImportMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_import_m.svg"
import ImportSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_import_s.svg"
import ImportExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_import_xl.svg"
import MenuLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_menu_l.svg"
import MenuMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_menu_m.svg"
import MenuSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_menu_s.svg"
import MenuExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_menu_xl.svg"
import MinusLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_minus_l.svg"
import MinusMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_minus_m.svg"
import MinusSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_minus_s.svg"
import MinusExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_minus_xl.svg"
import MinusExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_minus_xs.svg"
import MoreLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_more_l.svg"
import MoreMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_more_m.svg"
import MoreSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_more_s.svg"
import MoreExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_more_xl.svg"
import PercentLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_percent_l.svg"
import PercentMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_percent_m.svg"
import PercentSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_percent_s.svg"
import PercentExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_percent_xl.svg"
import PlusLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_plus_l.svg"
import PlusMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_plus_m.svg"
import PlusSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_plus_s.svg"
import PlusExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_plus_xl.svg"
import PlusExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_plus_xs.svg"
import ReloadLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_reload_l.svg"
import ReloadMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_reload_m.svg"
import ReloadSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_reload_s.svg"
import ReloadExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_reload_xl.svg"
import ReloadExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_reload_xs.svg"
import RevertLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_revert_l.svg"
import RevertMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_revert_m.svg"
import RevertSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_revert_s.svg"
import RevertExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_revert_xl.svg"
import RevertExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_revert_xs.svg"
import SimpleArrowDownLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_down_l.svg"
import SimpleArrowDownMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_down_m.svg"
import SimpleArrowDownSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_down_s.svg"
import SimpleArrowDownExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_down_xl.svg"
import SimpleArrowDownExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_down_xs.svg"
import SimpleArrowLeftLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_left_l.svg"
import SimpleArrowLeftMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_left_m.svg"
import SimpleArrowLeftSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_left_s.svg"
import SimpleArrowLeftExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_left_xl.svg"
import SimpleArrowLeftExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_left_xs.svg"
import SimpleArrowRightLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_right_l.svg"
import SimpleArrowRightMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_right_m.svg"
import SimpleArrowRightSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_right_s.svg"
import SimpleArrowRightExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_right_xl.svg"
import SimpleArrowRightExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_right_xs.svg"
import SimpleArrowUpLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_up_l.svg"
import SimpleArrowUpMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_up_m.svg"
import SimpleArrowUpSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_up_s.svg"
import SimpleArrowUpExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_up_xl.svg"
import SimpleArrowUpExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_simple_arrow_up_xs.svg"
import SortDownLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_down_l.svg"
import SortDownMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_down_m.svg"
import SortDownSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_down_s.svg"
import SortDownExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_down_xl.svg"
import SortDownExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_down_xs.svg"
import SortUpLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_up_l.svg"
import SortUpMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_up_m.svg"
import SortUpSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_up_s.svg"
import SortUpExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_up_xl.svg"
import SortUpExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_sort_up_xs.svg"
import TickLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_tick_l.svg"
import TickMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_tick_m.svg"
import TickSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_tick_s.svg"
import TickExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_tick_xl.svg"
import TickExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_tick_xs.svg"
import UndoLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_undo_l.svg"
import UndoMedium from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_undo_m.svg"
import UndoSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_undo_s.svg"
import UndoExtraLarge from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_undo_xl.svg"
import UndoExtraSmall from "../submodules/otto-icons/originalIcons/Simple and arrows/icon_undo_xs.svg"
import OneTwoThreeFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_123_filled_m.svg"
import OneTwoThreeFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_123_filled_s.svg"
import OneTwoThreeLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_123_l.svg"
import OneTwoThreeMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_123_m.svg"
import OneTwoThreeSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_123_s.svg"
import OneTwoThreeExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_123_xl.svg"
import AccessibilityMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_accessibility_m.svg"
import AppsSystemUpdateMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_apps_system_update_m.svg"
import BackspaceFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_backspace_filled_m.svg"
import BackspaceFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_backspace_filled_s.svg"
import BackspaceLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_backspace_l.svg"
import BackspaceMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_backspace_m.svg"
import BackspaceSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_backspace_s.svg"
import BackspaceExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_backspace_xl.svg"
import BankFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_bank_filled_m.svg"
import BankFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_bank_filled_s.svg"
import BankLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_bank_l.svg"
import BankMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_bank_m.svg"
import BankSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_bank_s.svg"
import BankExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_bank_xl.svg"
import BarcodeFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_barcode_filled_m.svg"
import BarcodeFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_barcode_filled_s.svg"
import BarcodeLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_barcode_l.svg"
import BarcodeMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_barcode_m.svg"
import BarcodeSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_barcode_s.svg"
import BarcodeExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_barcode_xl.svg"
import BarcodeokFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_barcodeok_filled_m.svg"
import BarcodeokFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_barcodeok_filled_s.svg"
import BarcodeokLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_barcodeok_l.svg"
import BarcodeokMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_barcodeok_m.svg"
import BarcodeokSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_barcodeok_s.svg"
import BarcodeokExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_barcodeok_xl.svg"
import BulletlistFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_bulletlist_filled_m.svg"
import BulletlistFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_bulletlist_filled_s.svg"
import BulletlistLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_bulletlist_l.svg"
import BulletlistMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_bulletlist_m.svg"
import BulletlistSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_bulletlist_s.svg"
import BulletlistExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_bulletlist_xl.svg"
import CardFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_card_filled_m.svg"
import CardFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_card_filled_s.svg"
import CardLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_card_l.svg"
import CardMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_card_m.svg"
import CardOverPhoneLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_card_over_phone_l.svg"
import CardOverPhoneMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_card_over_phone_m.svg"
import CardOverPhoneSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_card_over_phone_s.svg"
import CardOverPhoneExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_card_over_phone_xl.svg"
import CardSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_card_s.svg"
import CardExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_card_xl.svg"
import CashFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_cash_filled_m.svg"
import CashFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cash_filled_s.svg"
import CashLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_cash_l.svg"
import CashMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_cash_m.svg"
import CashSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cash_s.svg"
import CashExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_cash_xl.svg"
import ChatFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_chat_filled_m.svg"
import ChatFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_chat_filled_s.svg"
import ChatLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_chat_l.svg"
import ChatMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_chat_m.svg"
import ChatSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_chat_s.svg"
import ChatExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_chat_xl.svg"
import ChipFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_chip_filled_m.svg"
import ChipFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_chip_filled_s.svg"
import ChipLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_chip_l.svg"
import ChipMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_chip_m.svg"
import ChipSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_chip_s.svg"
import ChipExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_chip_xl.svg"
import CloudFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_cloud_filled_m.svg"
import CloudFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cloud_filled_s.svg"
import CloudLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_cloud_l.svg"
import CloudMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_cloud_m.svg"
import CloudSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cloud_s.svg"
import CloudExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_cloud_xl.svg"
import CogFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_filled_m.svg"
import CogFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_filled_s.svg"
import CogFilledExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_filled_xs.svg"
import CogLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_l.svg"
import CogMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_m.svg"
import CogSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_s.svg"
import CogExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_xl.svg"
import CogExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_cog_xs.svg"
import CopyClipboardLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_copy_clipboard_l.svg"
import CopyClipboardMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_copy_clipboard_m.svg"
import CopyClipboardSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_copy_clipboard_s.svg"
import CopyClipboardExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_copy_clipboard_xl.svg"
import DateFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_date_filled_m.svg"
import DateFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_date_filled_s.svg"
import DateLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_date_l.svg"
import DateMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_date_m.svg"
import DateSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_date_s.svg"
import DateExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_date_xl.svg"
import DateExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_date_xs.svg"
import DeliveryFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_delivery_filled_m.svg"
import DeliveryFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_delivery_filled_s.svg"
import DeliveryLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_delivery_l.svg"
import DeliveryMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_delivery_m.svg"
import DeliverySmall from "../submodules/otto-icons/originalIcons/Symbols/icon_delivery_s.svg"
import DeliveryExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_delivery_xl.svg"
import DepositFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_deposit_filled_m.svg"
import DepositFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_deposit_filled_s.svg"
import DepositLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_deposit_l.svg"
import DepositMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_deposit_m.svg"
import DepositSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_deposit_s.svg"
import DepositExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_deposit_xl.svg"
import EcommerceFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_ecommerce_filled_m.svg"
import EcommerceFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_ecommerce_filled_s.svg"
import EcommerceLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_ecommerce_l.svg"
import EcommerceMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_ecommerce_m.svg"
import EcommerceSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_ecommerce_s.svg"
import EcommerceExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_ecommerce_xl.svg"
import EditFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_edit_filled_m.svg"
import EditFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_edit_filled_s.svg"
import EditLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_edit_l.svg"
import EditMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_edit_m.svg"
import EditSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_edit_s.svg"
import EditExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_edit_xl.svg"
import EditExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_edit_xs.svg"
import EmailFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_email_filled_m.svg"
import EmailFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_email_filled_s.svg"
import EmailLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_email_l.svg"
import EmailMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_email_m.svg"
import EmailSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_email_s.svg"
import EmailExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_email_xl.svg"
import ErrorFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_error_filled_m.svg"
import ErrorFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_error_filled_s.svg"
import ErrorFilledExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_error_filled_xs.svg"
import ErrorLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_error_l.svg"
import ErrorMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_error_m.svg"
import ErrorSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_error_s.svg"
import ErrorExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_error_xl.svg"
import ErrorExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_error_xs.svg"
import FilterLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_filter_l.svg"
import FilterMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_filter_m.svg"
import FilterSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_filter_s.svg"
import FilterExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_filter_xl.svg"
import FilterExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_filter_xs.svg"
import FundingFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_funding_filled_m.svg"
import FundingFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_funding_filled_s.svg"
import FundingLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_funding_l.svg"
import FundingMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_funding_m.svg"
import FundingSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_funding_s.svg"
import FundingExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_funding_xl.svg"
import GiftCardLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_gift_card_l.svg"
import GiftCardMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_gift_card_m.svg"
import GiftCardSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_gift_card_s.svg"
import GiftCardExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_gift_card_xl.svg"
import GridOnex1Large from "../submodules/otto-icons/originalIcons/Symbols/icon_grid_1x1_l.svg"
import GridTwox2Large from "../submodules/otto-icons/originalIcons/Symbols/icon_grid_2x2_l.svg"
import GridThreex3Large from "../submodules/otto-icons/originalIcons/Symbols/icon_grid_3x3_l.svg"
import HeartFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_heart_filled_m.svg"
import HeartFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_heart_filled_s.svg"
import HeartLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_heart_l.svg"
import HeartMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_heart_m.svg"
import HeartSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_heart_s.svg"
import HeartExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_heart_xl.svg"
import HeartExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_heart_xs.svg"
import HideLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_hide_l.svg"
import HideMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_hide_m.svg"
import HideSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_hide_s.svg"
import HideExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_hide_xl.svg"
import HidekeyboardFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_hidekeyboard_filled_m.svg"
import HidekeyboardFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_hidekeyboard_filled_s.svg"
import HidekeyboardLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_hidekeyboard_l.svg"
import HidekeyboardMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_hidekeyboard_m.svg"
import HidekeyboardSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_hidekeyboard_s.svg"
import HidekeyboardExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_hidekeyboard_xl.svg"
import HomeFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_home_filled_m.svg"
import HomeFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_home_filled_s.svg"
import HomeLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_home_l.svg"
import HomeMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_home_m.svg"
import HomeSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_home_s.svg"
import HomeExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_home_xl.svg"
import IdCardFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_id_card_filled_m.svg"
import IdCardFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_id_card_filled_s.svg"
import IdCardLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_id_card_l.svg"
import IdCardMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_id_card_m.svg"
import IdCardSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_id_card_s.svg"
import IdCardExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_id_card_xl.svg"
import IdeaFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_idea_filled_m.svg"
import IdeaFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_idea_filled_s.svg"
import IdeaLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_idea_l.svg"
import IdeaMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_idea_m.svg"
import IdeaSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_idea_s.svg"
import IdeaExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_idea_xl.svg"
import IdentitycardFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_identitycard_filled_m.svg"
import IdentitycardFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_identitycard_filled_s.svg"
import IdentitycardLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_identitycard_l.svg"
import IdentitycardMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_identitycard_m.svg"
import IdentitycardSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_identitycard_s.svg"
import IdentitycardExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_identitycard_xl.svg"
import InventoryLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_inventory_l.svg"
import InventoryMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_inventory_m.svg"
import InventorySmall from "../submodules/otto-icons/originalIcons/Symbols/icon_inventory_s.svg"
import InventoryExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_inventory_xl.svg"
import LetterFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_filled_m.svg"
import LetterFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_filled_s.svg"
import LetterLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_l.svg"
import LetterMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_m.svg"
import LetterRevertFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_revert_filled_m.svg"
import LetterRevertFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_revert_filled_s.svg"
import LetterRevertLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_revert_l.svg"
import LetterRevertMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_revert_m.svg"
import LetterRevertSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_revert_s.svg"
import LetterRevertExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_revert_xl.svg"
import LetterSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_s.svg"
import LetterExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_letter_xl.svg"
import LibraryFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_library_filled_m.svg"
import LibraryFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_library_filled_s.svg"
import LibraryLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_library_l.svg"
import LibraryMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_library_m.svg"
import LibrarySmall from "../submodules/otto-icons/originalIcons/Symbols/icon_library_s.svg"
import LibraryExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_library_xl.svg"
import LockFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_lock_filled_m.svg"
import LockFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_lock_filled_s.svg"
import LockLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_lock_l.svg"
import LockMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_lock_m.svg"
import LockSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_lock_s.svg"
import LockExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_lock_xl.svg"
import MappinFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_mappin_filled_m.svg"
import MappinFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_mappin_filled_s.svg"
import MappinLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_mappin_l.svg"
import MappinMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_mappin_m.svg"
import MappinSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_mappin_s.svg"
import MappinExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_mappin_xl.svg"
import MoneyWarningLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_money_warning_l.svg"
import MoneyWarningMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_money_warning_m.svg"
import MoneyWarningSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_money_warning_s.svg"
import MoneyWarningExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_money_warning_xl.svg"
import MoneybagFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_moneybag_filled_m.svg"
import MoneybagFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_moneybag_filled_s.svg"
import MoneybagLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_moneybag_l.svg"
import MoneybagMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_moneybag_m.svg"
import MoneybagSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_moneybag_s.svg"
import MoneybagExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_moneybag_xl.svg"
import MountingMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_mounting_m.svg"
import MultipaymentsLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_multipayments_l.svg"
import MultipaymentsMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_multipayments_m.svg"
import MultipaymentsSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_multipayments_s.svg"
import MultipaymentsExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_multipayments_xl.svg"
import NavigationMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_navigation_m.svg"
import NotificationFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_notification_filled_m.svg"
import NotificationFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_notification_filled_s.svg"
import NotificationLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_notification_l.svg"
import NotificationMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_notification_m.svg"
import NotificationSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_notification_s.svg"
import NotificationExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_notification_xl.svg"
import OnlinePayLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_online_pay_l.svg"
import OnlinePayMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_online_pay_m.svg"
import OnlinePaySmall from "../submodules/otto-icons/originalIcons/Symbols/icon_online_pay_s.svg"
import OnlinePayExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_online_pay_xl.svg"
import OpenInNewLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_open_in_new_l.svg"
import OpenInNewMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_open_in_new_m.svg"
import OpenInNewSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_open_in_new_s.svg"
import OpenInNewExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_open_in_new_xl.svg"
import OpenInNewExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_open_in_new_xs.svg"
import OrdersLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_orders_l.svg"
import OrdersMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_orders_m.svg"
import OrdersSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_orders_s.svg"
import OrdersExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_orders_xl.svg"
import PaymentOptionsLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_payment_options_l.svg"
import PaymentOptionsMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_payment_options_m.svg"
import PaymentOptionsSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_payment_options_s.svg"
import PaymentOptionsExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_payment_options_xl.svg"
import PdfFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_pdf_filled_m.svg"
import PdfFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_pdf_filled_s.svg"
import PdfLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_pdf_l.svg"
import PdfMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_pdf_m.svg"
import PdfSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_pdf_s.svg"
import PdfExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_pdf_xl.svg"
import PersonTwoLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person2_l.svg"
import PersonTwoMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_person2_m.svg"
import PersonTwoSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_person2_s.svg"
import PersonTwoExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person2_xl.svg"
import PersonThreeLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person3_l.svg"
import PersonThreeMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_person3_m.svg"
import PersonThreeSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_person3_s.svg"
import PersonThreeExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person3_xl.svg"
import PersonFourLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person4_l.svg"
import PersonFourMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_person4_m.svg"
import PersonFourSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_person4_s.svg"
import PersonFourExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person4_xl.svg"
import PersonFiveLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person5_l.svg"
import PersonFiveMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_person5_m.svg"
import PersonFiveSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_person5_s.svg"
import PersonFiveExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person5_xl.svg"
import PersonFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_person_filled_m.svg"
import PersonFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_person_filled_s.svg"
import PersonLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person_l.svg"
import PersonMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_person_m.svg"
import PersonSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_person_s.svg"
import PersonExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_person_xl.svg"
import PiechartFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_piechart_filled_m.svg"
import PiechartFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_piechart_filled_s.svg"
import PiechartLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_piechart_l.svg"
import PiechartMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_piechart_m.svg"
import PiechartSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_piechart_s.svg"
import PiechartExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_piechart_xl.svg"
import PrinterPaperRollMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_printer_paper_roll_m.svg"
import ProductsFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_products_filled_m.svg"
import ProductsFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_products_filled_s.svg"
import ProductsLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_products_l.svg"
import ProductsMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_products_m.svg"
import ProductsSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_products_s.svg"
import ProductsExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_products_xl.svg"
import PuzzleFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_puzzle_filled_m.svg"
import PuzzleFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_puzzle_filled_s.svg"
import PuzzleLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_puzzle_l.svg"
import PuzzleMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_puzzle_m.svg"
import PuzzleSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_puzzle_s.svg"
import PuzzleExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_puzzle_xl.svg"
import QrCodeLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_qr_code_l.svg"
import QrCodeMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_qr_code_m.svg"
import QrCodeSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_qr_code_s.svg"
import QrCodeExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_qr_code_xl.svg"
import ReceiptFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_receipt_filled_m.svg"
import ReceiptFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_receipt_filled_s.svg"
import ReceiptLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_receipt_l.svg"
import ReceiptMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_receipt_m.svg"
import ReceiptSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_receipt_s.svg"
import ReceiptExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_receipt_xl.svg"
import RefundLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_refund_l.svg"
import RefundMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_refund_m.svg"
import RefundSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_refund_s.svg"
import RefundExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_refund_xl.svg"
import ReorderMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_reorder_m.svg"
import ReorderSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_reorder_s.svg"
import ReportsFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_reports_filled_m.svg"
import ReportsFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_reports_filled_s.svg"
import ReportsLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_reports_l.svg"
import ReportsMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_reports_m.svg"
import ReportsSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_reports_s.svg"
import ReportsExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_reports_xl.svg"
import SearchFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_search_filled_m.svg"
import SearchFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_search_filled_s.svg"
import SearchLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_search_l.svg"
import SearchMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_search_m.svg"
import SearchSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_search_s.svg"
import SearchExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_search_xl.svg"
import SendFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_send_filled_m.svg"
import SendFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_send_filled_s.svg"
import SendLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_send_l.svg"
import SendMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_send_m.svg"
import SendSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_send_s.svg"
import SendExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_send_xl.svg"
import SettingsFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_settings_filled_m.svg"
import SettingsFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_settings_filled_s.svg"
import SettingsLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_settings_l.svg"
import SettingsMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_settings_m.svg"
import SettingsSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_settings_s.svg"
import SettingsExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_settings_xl.svg"
import SettingsExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_settings_xs.svg"
import ShareFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_share_filled_m.svg"
import ShareFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_share_filled_s.svg"
import ShareLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_share_l.svg"
import ShareMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_share_m.svg"
import ShareSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_share_s.svg"
import ShareExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_share_xl.svg"
import ShoppingBasketFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shopping_basket_filled_m.svg"
import ShoppingBasketFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shopping_basket_filled_s.svg"
import ShoppingBasketLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shopping_basket_l.svg"
import ShoppingBasketMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shopping_basket_m.svg"
import ShoppingBasketSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shopping_basket_s.svg"
import ShoppingBasketExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shopping_basket_xl.svg"
import ShoppingbagFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingbag_filled_m.svg"
import ShoppingbagFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingbag_filled_s.svg"
import ShoppingbagLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingbag_l.svg"
import ShoppingbagMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingbag_m.svg"
import ShoppingbagSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingbag_s.svg"
import ShoppingbagExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingbag_xl.svg"
import ShoppingcartFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingcart_filled_m.svg"
import ShoppingcartFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingcart_filled_s.svg"
import ShoppingcartLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingcart_l.svg"
import ShoppingcartMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingcart_m.svg"
import ShoppingcartSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingcart_s.svg"
import ShoppingcartExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shoppingcart_xl.svg"
import ShowLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_show_l.svg"
import ShowMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_show_m.svg"
import ShowSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_show_s.svg"
import ShowExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_show_xl.svg"
import ShutdownFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shutdown_filled_m.svg"
import ShutdownFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shutdown_filled_s.svg"
import ShutdownLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shutdown_l.svg"
import ShutdownMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_shutdown_m.svg"
import ShutdownSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_shutdown_s.svg"
import ShutdownExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_shutdown_xl.svg"
import StaffFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_staff_filled_m.svg"
import StaffFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_staff_filled_s.svg"
import StaffLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_staff_l.svg"
import StaffMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_staff_m.svg"
import StaffSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_staff_s.svg"
import StaffExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_staff_xl.svg"
import StarFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_star_filled_m.svg"
import StarFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_star_filled_s.svg"
import StarLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_star_l.svg"
import StarMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_star_m.svg"
import StarSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_star_s.svg"
import StarExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_star_xl.svg"
import StarExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_star_xs.svg"
import TagFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_tag_filled_m.svg"
import TagFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_tag_filled_s.svg"
import TagLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_tag_l.svg"
import TagMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_tag_m.svg"
import TagSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_tag_s.svg"
import TagExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_tag_xl.svg"
import TapPhoneLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_tap_phone_l.svg"
import TapPhoneMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_tap_phone_m.svg"
import TapPhoneSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_tap_phone_s.svg"
import TapPhoneExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_tap_phone_xl.svg"
import TaxesLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_taxes_l.svg"
import TaxesMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_taxes_m.svg"
import TaxesSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_taxes_s.svg"
import TaxesExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_taxes_xl.svg"
import TaxesExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_taxes_xs.svg"
import TipsLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_tips_l.svg"
import TipsMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_tips_m.svg"
import TipsSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_tips_s.svg"
import TipsExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_tips_xl.svg"
import TrashFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_trash_filled_m.svg"
import TrashFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_trash_filled_s.svg"
import TrashLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_trash_l.svg"
import TrashMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_trash_m.svg"
import TrashSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_trash_s.svg"
import TrashExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_trash_xl.svg"
import TrashExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_trash_xs.svg"
import UnknownPaymentLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_unknown_payment_l.svg"
import UnknownPaymentMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_unknown_payment_m.svg"
import UnknownPaymentSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_unknown_payment_s.svg"
import UnknownPaymentExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_unknown_payment_xl.svg"
import UnlockedFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_unlocked_filled_m.svg"
import UnlockedFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_unlocked_filled_s.svg"
import UnlockedLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_unlocked_l.svg"
import UnlockedMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_unlocked_m.svg"
import UnlockedSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_unlocked_s.svg"
import UnlockedExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_unlocked_xl.svg"
import UserGenericLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_user_generic_l.svg"
import UserGenericMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_user_generic_m.svg"
import UserGenericSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_user_generic_s.svg"
import UserGenericExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_user_generic_xl.svg"
import UserGenericExtraSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_user_generic_xs.svg"
import VolumeFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_volume_filled_m.svg"
import VolumeFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_volume_filled_s.svg"
import VolumeLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_volume_l.svg"
import VolumeMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_volume_m.svg"
import VolumeSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_volume_s.svg"
import VolumeExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_volume_xl.svg"
import ZoominFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomin_filled_m.svg"
import ZoominFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomin_filled_s.svg"
import ZoominLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomin_l.svg"
import ZoominMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomin_m.svg"
import ZoominSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomin_s.svg"
import ZoominExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomin_xl.svg"
import ZoomoutFilledMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomout_filled_m.svg"
import ZoomoutFilledSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomout_filled_s.svg"
import ZoomoutLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomout_l.svg"
import ZoomoutMedium from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomout_m.svg"
import ZoomoutSmall from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomout_s.svg"
import ZoomoutExtraLarge from "../submodules/otto-icons/originalIcons/Symbols/icon_zoomout_xl.svg"


export enum IconSize {
 ExtraLarge = "ExtraLarge",
 Large = "Large",
 ExtraSmall = "ExtraSmall",
 Small = "Small",
 Medium = "Medium"
}

export const IconCircleCrossFilledExtraSmall = {
  name: "CircleCrossFilled",
  size: IconSize.ExtraSmall,
  svg: CircleCrossFilledExtraSmall
} as const

export const IconCircleCrossFilledSmall = {
  name: "CircleCrossFilled",
  size: IconSize.Small,
  svg: CircleCrossFilledSmall
} as const

export const IconCircleCrossFilledMedium = {
  name: "CircleCrossFilled",
  size: IconSize.Medium,
  svg: CircleCrossFilledMedium
} as const

export const IconCircleCrossExtraLarge = {
  name: "CircleCross",
  size: IconSize.ExtraLarge,
  svg: CircleCrossExtraLarge
} as const

export const IconCircleCrossLarge = {
  name: "CircleCross",
  size: IconSize.Large,
  svg: CircleCrossLarge
} as const

export const IconCircleCrossExtraSmall = {
  name: "CircleCross",
  size: IconSize.ExtraSmall,
  svg: CircleCrossExtraSmall
} as const

export const IconCircleCrossSmall = {
  name: "CircleCross",
  size: IconSize.Small,
  svg: CircleCrossSmall
} as const

export const IconCircleCrossMedium = {
  name: "CircleCross",
  size: IconSize.Medium,
  svg: CircleCrossMedium
} as const

export const IconCircleMinusExtraLarge = {
  name: "CircleMinus",
  size: IconSize.ExtraLarge,
  svg: CircleMinusExtraLarge
} as const

export const IconCircleMinusLarge = {
  name: "CircleMinus",
  size: IconSize.Large,
  svg: CircleMinusLarge
} as const

export const IconCircleMinusExtraSmall = {
  name: "CircleMinus",
  size: IconSize.ExtraSmall,
  svg: CircleMinusExtraSmall
} as const

export const IconCircleMinusSmall = {
  name: "CircleMinus",
  size: IconSize.Small,
  svg: CircleMinusSmall
} as const

export const IconCircleMinusMedium = {
  name: "CircleMinus",
  size: IconSize.Medium,
  svg: CircleMinusMedium
} as const

export const IconCirclePlusFilledExtraSmall = {
  name: "CirclePlusFilled",
  size: IconSize.ExtraSmall,
  svg: CirclePlusFilledExtraSmall
} as const

export const IconCirclePlusFilledSmall = {
  name: "CirclePlusFilled",
  size: IconSize.Small,
  svg: CirclePlusFilledSmall
} as const

export const IconCirclePlusFilledMedium = {
  name: "CirclePlusFilled",
  size: IconSize.Medium,
  svg: CirclePlusFilledMedium
} as const

export const IconCirclePlusExtraLarge = {
  name: "CirclePlus",
  size: IconSize.ExtraLarge,
  svg: CirclePlusExtraLarge
} as const

export const IconCirclePlusLarge = {
  name: "CirclePlus",
  size: IconSize.Large,
  svg: CirclePlusLarge
} as const

export const IconCirclePlusExtraSmall = {
  name: "CirclePlus",
  size: IconSize.ExtraSmall,
  svg: CirclePlusExtraSmall
} as const

export const IconCirclePlusSmall = {
  name: "CirclePlus",
  size: IconSize.Small,
  svg: CirclePlusSmall
} as const

export const IconCirclePlusMedium = {
  name: "CirclePlus",
  size: IconSize.Medium,
  svg: CirclePlusMedium
} as const

export const IconCircleTickFilledExtraSmall = {
  name: "CircleTickFilled",
  size: IconSize.ExtraSmall,
  svg: CircleTickFilledExtraSmall
} as const

export const IconCircleTickFilledSmall = {
  name: "CircleTickFilled",
  size: IconSize.Small,
  svg: CircleTickFilledSmall
} as const

export const IconCircleTickFilledMedium = {
  name: "CircleTickFilled",
  size: IconSize.Medium,
  svg: CircleTickFilledMedium
} as const

export const IconCircleTickExtraLarge = {
  name: "CircleTick",
  size: IconSize.ExtraLarge,
  svg: CircleTickExtraLarge
} as const

export const IconCircleTickLarge = {
  name: "CircleTick",
  size: IconSize.Large,
  svg: CircleTickLarge
} as const

export const IconCircleTickExtraSmall = {
  name: "CircleTick",
  size: IconSize.ExtraSmall,
  svg: CircleTickExtraSmall
} as const

export const IconCircleTickSmall = {
  name: "CircleTick",
  size: IconSize.Small,
  svg: CircleTickSmall
} as const

export const IconCircleTickMedium = {
  name: "CircleTick",
  size: IconSize.Medium,
  svg: CircleTickMedium
} as const

export const IconCircleTickOpenExtraLarge = {
  name: "CircleTickOpen",
  size: IconSize.ExtraLarge,
  svg: CircleTickOpenExtraLarge
} as const

export const IconCircleTickOpenLarge = {
  name: "CircleTickOpen",
  size: IconSize.Large,
  svg: CircleTickOpenLarge
} as const

export const IconCircleTickOpenExtraSmall = {
  name: "CircleTickOpen",
  size: IconSize.ExtraSmall,
  svg: CircleTickOpenExtraSmall
} as const

export const IconCircleTickOpenSmall = {
  name: "CircleTickOpen",
  size: IconSize.Small,
  svg: CircleTickOpenSmall
} as const

export const IconCircleTickOpenMedium = {
  name: "CircleTickOpen",
  size: IconSize.Medium,
  svg: CircleTickOpenMedium
} as const

export const IconClockExtraLarge = {
  name: "Clock",
  size: IconSize.ExtraLarge,
  svg: ClockExtraLarge
} as const

export const IconClockLarge = {
  name: "Clock",
  size: IconSize.Large,
  svg: ClockLarge
} as const

export const IconClockSmall = {
  name: "Clock",
  size: IconSize.Small,
  svg: ClockSmall
} as const

export const IconClockMedium = {
  name: "Clock",
  size: IconSize.Medium,
  svg: ClockMedium
} as const

export const IconCompassExtraLarge = {
  name: "Compass",
  size: IconSize.ExtraLarge,
  svg: CompassExtraLarge
} as const

export const IconCompassLarge = {
  name: "Compass",
  size: IconSize.Large,
  svg: CompassLarge
} as const

export const IconCompassSmall = {
  name: "Compass",
  size: IconSize.Small,
  svg: CompassSmall
} as const

export const IconCompassMedium = {
  name: "Compass",
  size: IconSize.Medium,
  svg: CompassMedium
} as const

export const IconDeadExtraLarge = {
  name: "Dead",
  size: IconSize.ExtraLarge,
  svg: DeadExtraLarge
} as const

export const IconDeadLarge = {
  name: "Dead",
  size: IconSize.Large,
  svg: DeadLarge
} as const

export const IconDeadSmall = {
  name: "Dead",
  size: IconSize.Small,
  svg: DeadSmall
} as const

export const IconDeadMedium = {
  name: "Dead",
  size: IconSize.Medium,
  svg: DeadMedium
} as const

export const IconDeniedExtraLarge = {
  name: "Denied",
  size: IconSize.ExtraLarge,
  svg: DeniedExtraLarge
} as const

export const IconDeniedLarge = {
  name: "Denied",
  size: IconSize.Large,
  svg: DeniedLarge
} as const

export const IconDeniedExtraSmall = {
  name: "Denied",
  size: IconSize.ExtraSmall,
  svg: DeniedExtraSmall
} as const

export const IconDeniedSmall = {
  name: "Denied",
  size: IconSize.Small,
  svg: DeniedSmall
} as const

export const IconDeniedMedium = {
  name: "Denied",
  size: IconSize.Medium,
  svg: DeniedMedium
} as const

export const IconHappyExtraLarge = {
  name: "Happy",
  size: IconSize.ExtraLarge,
  svg: HappyExtraLarge
} as const

export const IconHappyLarge = {
  name: "Happy",
  size: IconSize.Large,
  svg: HappyLarge
} as const

export const IconHappySmall = {
  name: "Happy",
  size: IconSize.Small,
  svg: HappySmall
} as const

export const IconHappyMedium = {
  name: "Happy",
  size: IconSize.Medium,
  svg: HappyMedium
} as const

export const IconHelpFilledExtraSmall = {
  name: "HelpFilled",
  size: IconSize.ExtraSmall,
  svg: HelpFilledExtraSmall
} as const

export const IconHelpFilledSmall = {
  name: "HelpFilled",
  size: IconSize.Small,
  svg: HelpFilledSmall
} as const

export const IconHelpFilledMedium = {
  name: "HelpFilled",
  size: IconSize.Medium,
  svg: HelpFilledMedium
} as const

export const IconHelpExtraLarge = {
  name: "Help",
  size: IconSize.ExtraLarge,
  svg: HelpExtraLarge
} as const

export const IconHelpLarge = {
  name: "Help",
  size: IconSize.Large,
  svg: HelpLarge
} as const

export const IconHelpExtraSmall = {
  name: "Help",
  size: IconSize.ExtraSmall,
  svg: HelpExtraSmall
} as const

export const IconHelpSmall = {
  name: "Help",
  size: IconSize.Small,
  svg: HelpSmall
} as const

export const IconHelpMedium = {
  name: "Help",
  size: IconSize.Medium,
  svg: HelpMedium
} as const

export const IconHumbleFailExtraLarge = {
  name: "HumbleFail",
  size: IconSize.ExtraLarge,
  svg: HumbleFailExtraLarge
} as const

export const IconHumbleFailLarge = {
  name: "HumbleFail",
  size: IconSize.Large,
  svg: HumbleFailLarge
} as const

export const IconHumbleFailSmall = {
  name: "HumbleFail",
  size: IconSize.Small,
  svg: HumbleFailSmall
} as const

export const IconHumbleFailMedium = {
  name: "HumbleFail",
  size: IconSize.Medium,
  svg: HumbleFailMedium
} as const

export const IconInfoFilledExtraSmall = {
  name: "InfoFilled",
  size: IconSize.ExtraSmall,
  svg: InfoFilledExtraSmall
} as const

export const IconInfoFilledSmall = {
  name: "InfoFilled",
  size: IconSize.Small,
  svg: InfoFilledSmall
} as const

export const IconInfoFilledMedium = {
  name: "InfoFilled",
  size: IconSize.Medium,
  svg: InfoFilledMedium
} as const

export const IconInfoExtraLarge = {
  name: "Info",
  size: IconSize.ExtraLarge,
  svg: InfoExtraLarge
} as const

export const IconInfoLarge = {
  name: "Info",
  size: IconSize.Large,
  svg: InfoLarge
} as const

export const IconInfoExtraSmall = {
  name: "Info",
  size: IconSize.ExtraSmall,
  svg: InfoExtraSmall
} as const

export const IconInfoSmall = {
  name: "Info",
  size: IconSize.Small,
  svg: InfoSmall
} as const

export const IconInfoMedium = {
  name: "Info",
  size: IconSize.Medium,
  svg: InfoMedium
} as const

export const IconSadExtraLarge = {
  name: "Sad",
  size: IconSize.ExtraLarge,
  svg: SadExtraLarge
} as const

export const IconSadLarge = {
  name: "Sad",
  size: IconSize.Large,
  svg: SadLarge
} as const

export const IconSadSmall = {
  name: "Sad",
  size: IconSize.Small,
  svg: SadSmall
} as const

export const IconSadMedium = {
  name: "Sad",
  size: IconSize.Medium,
  svg: SadMedium
} as const

export const IconVeryHappyExtraLarge = {
  name: "VeryHappy",
  size: IconSize.ExtraLarge,
  svg: VeryHappyExtraLarge
} as const

export const IconVeryHappyLarge = {
  name: "VeryHappy",
  size: IconSize.Large,
  svg: VeryHappyLarge
} as const

export const IconVeryHappySmall = {
  name: "VeryHappy",
  size: IconSize.Small,
  svg: VeryHappySmall
} as const

export const IconVeryHappyMedium = {
  name: "VeryHappy",
  size: IconSize.Medium,
  svg: VeryHappyMedium
} as const

export const IconWarningFilledExtraSmall = {
  name: "WarningFilled",
  size: IconSize.ExtraSmall,
  svg: WarningFilledExtraSmall
} as const

export const IconWarningFilledSmall = {
  name: "WarningFilled",
  size: IconSize.Small,
  svg: WarningFilledSmall
} as const

export const IconWarningFilledMedium = {
  name: "WarningFilled",
  size: IconSize.Medium,
  svg: WarningFilledMedium
} as const

export const IconWarningExtraLarge = {
  name: "Warning",
  size: IconSize.ExtraLarge,
  svg: WarningExtraLarge
} as const

export const IconWarningLarge = {
  name: "Warning",
  size: IconSize.Large,
  svg: WarningLarge
} as const

export const IconWarningExtraSmall = {
  name: "Warning",
  size: IconSize.ExtraSmall,
  svg: WarningExtraSmall
} as const

export const IconWarningSmall = {
  name: "Warning",
  size: IconSize.Small,
  svg: WarningSmall
} as const

export const IconWarningMedium = {
  name: "Warning",
  size: IconSize.Medium,
  svg: WarningMedium
} as const

export const IconBarZeroOneLarge = {
  name: "BarZeroOne",
  size: IconSize.Large,
  svg: BarZeroOneLarge
} as const

export const IconBarZeroOneSmall = {
  name: "BarZeroOne",
  size: IconSize.Small,
  svg: BarZeroOneSmall
} as const

export const IconBarZeroOneMedium = {
  name: "BarZeroOne",
  size: IconSize.Medium,
  svg: BarZeroOneMedium
} as const

export const IconBarZeroTwoLarge = {
  name: "BarZeroTwo",
  size: IconSize.Large,
  svg: BarZeroTwoLarge
} as const

export const IconBarZeroTwoSmall = {
  name: "BarZeroTwo",
  size: IconSize.Small,
  svg: BarZeroTwoSmall
} as const

export const IconBarZeroTwoMedium = {
  name: "BarZeroTwo",
  size: IconSize.Medium,
  svg: BarZeroTwoMedium
} as const

export const IconBarZeroThreeLarge = {
  name: "BarZeroThree",
  size: IconSize.Large,
  svg: BarZeroThreeLarge
} as const

export const IconBarZeroThreeSmall = {
  name: "BarZeroThree",
  size: IconSize.Small,
  svg: BarZeroThreeSmall
} as const

export const IconBarZeroThreeMedium = {
  name: "BarZeroThree",
  size: IconSize.Medium,
  svg: BarZeroThreeMedium
} as const

export const IconBycicleLarge = {
  name: "Bycicle",
  size: IconSize.Large,
  svg: BycicleLarge
} as const

export const IconBycicleSmall = {
  name: "Bycicle",
  size: IconSize.Small,
  svg: BycicleSmall
} as const

export const IconBycicleMedium = {
  name: "Bycicle",
  size: IconSize.Medium,
  svg: BycicleMedium
} as const

export const IconCookingLarge = {
  name: "Cooking",
  size: IconSize.Large,
  svg: CookingLarge
} as const

export const IconCookingSmall = {
  name: "Cooking",
  size: IconSize.Small,
  svg: CookingSmall
} as const

export const IconCookingMedium = {
  name: "Cooking",
  size: IconSize.Medium,
  svg: CookingMedium
} as const

export const IconCutleryZeroOneLarge = {
  name: "CutleryZeroOne",
  size: IconSize.Large,
  svg: CutleryZeroOneLarge
} as const

export const IconCutleryZeroOneSmall = {
  name: "CutleryZeroOne",
  size: IconSize.Small,
  svg: CutleryZeroOneSmall
} as const

export const IconCutleryZeroOneMedium = {
  name: "CutleryZeroOne",
  size: IconSize.Medium,
  svg: CutleryZeroOneMedium
} as const

export const IconCutleryZeroTwoLarge = {
  name: "CutleryZeroTwo",
  size: IconSize.Large,
  svg: CutleryZeroTwoLarge
} as const

export const IconCutleryZeroTwoSmall = {
  name: "CutleryZeroTwo",
  size: IconSize.Small,
  svg: CutleryZeroTwoSmall
} as const

export const IconCutleryZeroTwoMedium = {
  name: "CutleryZeroTwo",
  size: IconSize.Medium,
  svg: CutleryZeroTwoMedium
} as const

export const IconCutleryZeroThreeLarge = {
  name: "CutleryZeroThree",
  size: IconSize.Large,
  svg: CutleryZeroThreeLarge
} as const

export const IconCutleryZeroThreeSmall = {
  name: "CutleryZeroThree",
  size: IconSize.Small,
  svg: CutleryZeroThreeSmall
} as const

export const IconCutleryZeroThreeMedium = {
  name: "CutleryZeroThree",
  size: IconSize.Medium,
  svg: CutleryZeroThreeMedium
} as const

export const IconDeliveryBagLarge = {
  name: "DeliveryBag",
  size: IconSize.Large,
  svg: DeliveryBagLarge
} as const

export const IconDeliveryBagSmall = {
  name: "DeliveryBag",
  size: IconSize.Small,
  svg: DeliveryBagSmall
} as const

export const IconDeliveryBagMedium = {
  name: "DeliveryBag",
  size: IconSize.Medium,
  svg: DeliveryBagMedium
} as const

export const IconKitchenbellLarge = {
  name: "Kitchenbell",
  size: IconSize.Large,
  svg: KitchenbellLarge
} as const

export const IconKitchenbellSmall = {
  name: "Kitchenbell",
  size: IconSize.Small,
  svg: KitchenbellSmall
} as const

export const IconKitchenbellMedium = {
  name: "Kitchenbell",
  size: IconSize.Medium,
  svg: KitchenbellMedium
} as const

export const IconPrepFoodLarge = {
  name: "PrepFood",
  size: IconSize.Large,
  svg: PrepFoodLarge
} as const

export const IconPrepFoodSmall = {
  name: "PrepFood",
  size: IconSize.Small,
  svg: PrepFoodSmall
} as const

export const IconPrepFoodMedium = {
  name: "PrepFood",
  size: IconSize.Medium,
  svg: PrepFoodMedium
} as const

export const IconStopwatchLarge = {
  name: "Stopwatch",
  size: IconSize.Large,
  svg: StopwatchLarge
} as const

export const IconStopwatchSmall = {
  name: "Stopwatch",
  size: IconSize.Small,
  svg: StopwatchSmall
} as const

export const IconStopwatchMedium = {
  name: "Stopwatch",
  size: IconSize.Medium,
  svg: StopwatchMedium
} as const

export const IconTableLarge = {
  name: "Table",
  size: IconSize.Large,
  svg: TableLarge
} as const

export const IconTableSmall = {
  name: "Table",
  size: IconSize.Small,
  svg: TableSmall
} as const

export const IconTableMedium = {
  name: "Table",
  size: IconSize.Medium,
  svg: TableMedium
} as const

export const IconTableNumberLarge = {
  name: "TableNumber",
  size: IconSize.Large,
  svg: TableNumberLarge
} as const

export const IconTableNumberSmall = {
  name: "TableNumber",
  size: IconSize.Small,
  svg: TableNumberSmall
} as const

export const IconTableNumberMedium = {
  name: "TableNumber",
  size: IconSize.Medium,
  svg: TableNumberMedium
} as const

export const IconTimerLarge = {
  name: "Timer",
  size: IconSize.Large,
  svg: TimerLarge
} as const

export const IconTimerSmall = {
  name: "Timer",
  size: IconSize.Small,
  svg: TimerSmall
} as const

export const IconTimerMedium = {
  name: "Timer",
  size: IconSize.Medium,
  svg: TimerMedium
} as const

export const IconBatteryChargingExtraLarge = {
  name: "BatteryCharging",
  size: IconSize.ExtraLarge,
  svg: BatteryChargingExtraLarge
} as const

export const IconBatteryChargingLarge = {
  name: "BatteryCharging",
  size: IconSize.Large,
  svg: BatteryChargingLarge
} as const

export const IconBatteryChargingExtraSmall = {
  name: "BatteryCharging",
  size: IconSize.ExtraSmall,
  svg: BatteryChargingExtraSmall
} as const

export const IconBatteryChargingSmall = {
  name: "BatteryCharging",
  size: IconSize.Small,
  svg: BatteryChargingSmall
} as const

export const IconBatteryChargingMedium = {
  name: "BatteryCharging",
  size: IconSize.Medium,
  svg: BatteryChargingMedium
} as const

export const IconBatteryCriticalExtraLarge = {
  name: "BatteryCritical",
  size: IconSize.ExtraLarge,
  svg: BatteryCriticalExtraLarge
} as const

export const IconBatteryCriticalLarge = {
  name: "BatteryCritical",
  size: IconSize.Large,
  svg: BatteryCriticalLarge
} as const

export const IconBatteryCriticalExtraSmall = {
  name: "BatteryCritical",
  size: IconSize.ExtraSmall,
  svg: BatteryCriticalExtraSmall
} as const

export const IconBatteryCriticalSmall = {
  name: "BatteryCritical",
  size: IconSize.Small,
  svg: BatteryCriticalSmall
} as const

export const IconBatteryCriticalMedium = {
  name: "BatteryCritical",
  size: IconSize.Medium,
  svg: BatteryCriticalMedium
} as const

export const IconBatteryEmptyExtraLarge = {
  name: "BatteryEmpty",
  size: IconSize.ExtraLarge,
  svg: BatteryEmptyExtraLarge
} as const

export const IconBatteryEmptyLarge = {
  name: "BatteryEmpty",
  size: IconSize.Large,
  svg: BatteryEmptyLarge
} as const

export const IconBatteryEmptyExtraSmall = {
  name: "BatteryEmpty",
  size: IconSize.ExtraSmall,
  svg: BatteryEmptyExtraSmall
} as const

export const IconBatteryEmptySmall = {
  name: "BatteryEmpty",
  size: IconSize.Small,
  svg: BatteryEmptySmall
} as const

export const IconBatteryEmptyMedium = {
  name: "BatteryEmpty",
  size: IconSize.Medium,
  svg: BatteryEmptyMedium
} as const

export const IconBatteryOneBarExtraLarge = {
  name: "BatteryOneBar",
  size: IconSize.ExtraLarge,
  svg: BatteryOneBarExtraLarge
} as const

export const IconBatteryOneBarLarge = {
  name: "BatteryOneBar",
  size: IconSize.Large,
  svg: BatteryOneBarLarge
} as const

export const IconBatteryOneBarExtraSmall = {
  name: "BatteryOneBar",
  size: IconSize.ExtraSmall,
  svg: BatteryOneBarExtraSmall
} as const

export const IconBatteryOneBarSmall = {
  name: "BatteryOneBar",
  size: IconSize.Small,
  svg: BatteryOneBarSmall
} as const

export const IconBatteryOneBarMedium = {
  name: "BatteryOneBar",
  size: IconSize.Medium,
  svg: BatteryOneBarMedium
} as const

export const IconBatteryThreeBarsExtraLarge = {
  name: "BatteryThreeBars",
  size: IconSize.ExtraLarge,
  svg: BatteryThreeBarsExtraLarge
} as const

export const IconBatteryThreeBarsLarge = {
  name: "BatteryThreeBars",
  size: IconSize.Large,
  svg: BatteryThreeBarsLarge
} as const

export const IconBatteryThreeBarsExtraSmall = {
  name: "BatteryThreeBars",
  size: IconSize.ExtraSmall,
  svg: BatteryThreeBarsExtraSmall
} as const

export const IconBatteryThreeBarsSmall = {
  name: "BatteryThreeBars",
  size: IconSize.Small,
  svg: BatteryThreeBarsSmall
} as const

export const IconBatteryThreeBarsMedium = {
  name: "BatteryThreeBars",
  size: IconSize.Medium,
  svg: BatteryThreeBarsMedium
} as const

export const IconBatteryTwoBarsExtraLarge = {
  name: "BatteryTwoBars",
  size: IconSize.ExtraLarge,
  svg: BatteryTwoBarsExtraLarge
} as const

export const IconBatteryTwoBarsLarge = {
  name: "BatteryTwoBars",
  size: IconSize.Large,
  svg: BatteryTwoBarsLarge
} as const

export const IconBatteryTwoBarsExtraSmall = {
  name: "BatteryTwoBars",
  size: IconSize.ExtraSmall,
  svg: BatteryTwoBarsExtraSmall
} as const

export const IconBatteryTwoBarsSmall = {
  name: "BatteryTwoBars",
  size: IconSize.Small,
  svg: BatteryTwoBarsSmall
} as const

export const IconBatteryTwoBarsMedium = {
  name: "BatteryTwoBars",
  size: IconSize.Medium,
  svg: BatteryTwoBarsMedium
} as const

export const IconCameraExtraLarge = {
  name: "Camera",
  size: IconSize.ExtraLarge,
  svg: CameraExtraLarge
} as const

export const IconCameraLarge = {
  name: "Camera",
  size: IconSize.Large,
  svg: CameraLarge
} as const

export const IconCameraExtraSmall = {
  name: "Camera",
  size: IconSize.ExtraSmall,
  svg: CameraExtraSmall
} as const

export const IconCameraSmall = {
  name: "Camera",
  size: IconSize.Small,
  svg: CameraSmall
} as const

export const IconCameraMedium = {
  name: "Camera",
  size: IconSize.Medium,
  svg: CameraMedium
} as const

export const IconCardReaderOneDisconnectedExtraLarge = {
  name: "CardReaderOneDisconnected",
  size: IconSize.ExtraLarge,
  svg: CardReaderOneDisconnectedExtraLarge
} as const

export const IconCardReaderOneDisconnectedLarge = {
  name: "CardReaderOneDisconnected",
  size: IconSize.Large,
  svg: CardReaderOneDisconnectedLarge
} as const

export const IconCardReaderOneDisconnectedSmall = {
  name: "CardReaderOneDisconnected",
  size: IconSize.Small,
  svg: CardReaderOneDisconnectedSmall
} as const

export const IconCardReaderOneDisconnectedMedium = {
  name: "CardReaderOneDisconnected",
  size: IconSize.Medium,
  svg: CardReaderOneDisconnectedMedium
} as const

export const IconCardReaderOneExtraLarge = {
  name: "CardReaderOne",
  size: IconSize.ExtraLarge,
  svg: CardReaderOneExtraLarge
} as const

export const IconCardReaderOneLarge = {
  name: "CardReaderOne",
  size: IconSize.Large,
  svg: CardReaderOneLarge
} as const

export const IconCardReaderOneSmall = {
  name: "CardReaderOne",
  size: IconSize.Small,
  svg: CardReaderOneSmall
} as const

export const IconCardReaderOneMedium = {
  name: "CardReaderOne",
  size: IconSize.Medium,
  svg: CardReaderOneMedium
} as const

export const IconCashDrawerFilledSmall = {
  name: "CashDrawerFilled",
  size: IconSize.Small,
  svg: CashDrawerFilledSmall
} as const

export const IconCashDrawerFilledMedium = {
  name: "CashDrawerFilled",
  size: IconSize.Medium,
  svg: CashDrawerFilledMedium
} as const

export const IconCashDrawerExtraLarge = {
  name: "CashDrawer",
  size: IconSize.ExtraLarge,
  svg: CashDrawerExtraLarge
} as const

export const IconCashDrawerLarge = {
  name: "CashDrawer",
  size: IconSize.Large,
  svg: CashDrawerLarge
} as const

export const IconCashDrawerSmall = {
  name: "CashDrawer",
  size: IconSize.Small,
  svg: CashDrawerSmall
} as const

export const IconCashDrawerMedium = {
  name: "CashDrawer",
  size: IconSize.Medium,
  svg: CashDrawerMedium
} as const

export const IconHeadphonesExtraLarge = {
  name: "Headphones",
  size: IconSize.ExtraLarge,
  svg: HeadphonesExtraLarge
} as const

export const IconHeadphonesLarge = {
  name: "Headphones",
  size: IconSize.Large,
  svg: HeadphonesLarge
} as const

export const IconHeadphonesSmall = {
  name: "Headphones",
  size: IconSize.Small,
  svg: HeadphonesSmall
} as const

export const IconHeadphonesMedium = {
  name: "Headphones",
  size: IconSize.Medium,
  svg: HeadphonesMedium
} as const

export const IconLaptopExtraLarge = {
  name: "Laptop",
  size: IconSize.ExtraLarge,
  svg: LaptopExtraLarge
} as const

export const IconLaptopLarge = {
  name: "Laptop",
  size: IconSize.Large,
  svg: LaptopLarge
} as const

export const IconLaptopSmall = {
  name: "Laptop",
  size: IconSize.Small,
  svg: LaptopSmall
} as const

export const IconLaptopMedium = {
  name: "Laptop",
  size: IconSize.Medium,
  svg: LaptopMedium
} as const

export const IconMicrophoneExtraLarge = {
  name: "Microphone",
  size: IconSize.ExtraLarge,
  svg: MicrophoneExtraLarge
} as const

export const IconMicrophoneLarge = {
  name: "Microphone",
  size: IconSize.Large,
  svg: MicrophoneLarge
} as const

export const IconMicrophoneSmall = {
  name: "Microphone",
  size: IconSize.Small,
  svg: MicrophoneSmall
} as const

export const IconMicrophoneMedium = {
  name: "Microphone",
  size: IconSize.Medium,
  svg: MicrophoneMedium
} as const

export const IconMiuraDisconnectedExtraLarge = {
  name: "MiuraDisconnected",
  size: IconSize.ExtraLarge,
  svg: MiuraDisconnectedExtraLarge
} as const

export const IconMiuraDisconnectedLarge = {
  name: "MiuraDisconnected",
  size: IconSize.Large,
  svg: MiuraDisconnectedLarge
} as const

export const IconMiuraDisconnectedSmall = {
  name: "MiuraDisconnected",
  size: IconSize.Small,
  svg: MiuraDisconnectedSmall
} as const

export const IconMiuraDisconnectedMedium = {
  name: "MiuraDisconnected",
  size: IconSize.Medium,
  svg: MiuraDisconnectedMedium
} as const

export const IconMiuraExtraLarge = {
  name: "Miura",
  size: IconSize.ExtraLarge,
  svg: MiuraExtraLarge
} as const

export const IconMiuraLarge = {
  name: "Miura",
  size: IconSize.Large,
  svg: MiuraLarge
} as const

export const IconMiuraSmall = {
  name: "Miura",
  size: IconSize.Small,
  svg: MiuraSmall
} as const

export const IconMiuraMedium = {
  name: "Miura",
  size: IconSize.Medium,
  svg: MiuraMedium
} as const

export const IconPeripheralsExtraLarge = {
  name: "Peripherals",
  size: IconSize.ExtraLarge,
  svg: PeripheralsExtraLarge
} as const

export const IconPeripheralsLarge = {
  name: "Peripherals",
  size: IconSize.Large,
  svg: PeripheralsLarge
} as const

export const IconPeripheralsSmall = {
  name: "Peripherals",
  size: IconSize.Small,
  svg: PeripheralsSmall
} as const

export const IconPeripheralsMedium = {
  name: "Peripherals",
  size: IconSize.Medium,
  svg: PeripheralsMedium
} as const

export const IconPhoneExtraLarge = {
  name: "Phone",
  size: IconSize.ExtraLarge,
  svg: PhoneExtraLarge
} as const

export const IconPhoneLarge = {
  name: "Phone",
  size: IconSize.Large,
  svg: PhoneLarge
} as const

export const IconPhoneSmall = {
  name: "Phone",
  size: IconSize.Small,
  svg: PhoneSmall
} as const

export const IconPhoneMedium = {
  name: "Phone",
  size: IconSize.Medium,
  svg: PhoneMedium
} as const

export const IconPrinterBatteryOnebarMedium = {
  name: "PrinterBatteryOnebar",
  size: IconSize.Medium,
  svg: PrinterBatteryOnebarMedium
} as const

export const IconPrinterBatteryTwobarsMedium = {
  name: "PrinterBatteryTwobars",
  size: IconSize.Medium,
  svg: PrinterBatteryTwobarsMedium
} as const

export const IconPrinterBatteryThreebarsMedium = {
  name: "PrinterBatteryThreebars",
  size: IconSize.Medium,
  svg: PrinterBatteryThreebarsMedium
} as const

export const IconPrinterBatteryChargingMedium = {
  name: "PrinterBatteryCharging",
  size: IconSize.Medium,
  svg: PrinterBatteryChargingMedium
} as const

export const IconPrinterBatteryCriticalMedium = {
  name: "PrinterBatteryCritical",
  size: IconSize.Medium,
  svg: PrinterBatteryCriticalMedium
} as const

export const IconReceiptPrinterFilledSmall = {
  name: "ReceiptPrinterFilled",
  size: IconSize.Small,
  svg: ReceiptPrinterFilledSmall
} as const

export const IconReceiptPrinterFilledMedium = {
  name: "ReceiptPrinterFilled",
  size: IconSize.Medium,
  svg: ReceiptPrinterFilledMedium
} as const

export const IconReceiptPrinterExtraLarge = {
  name: "ReceiptPrinter",
  size: IconSize.ExtraLarge,
  svg: ReceiptPrinterExtraLarge
} as const

export const IconReceiptPrinterLarge = {
  name: "ReceiptPrinter",
  size: IconSize.Large,
  svg: ReceiptPrinterLarge
} as const

export const IconReceiptPrinterSmall = {
  name: "ReceiptPrinter",
  size: IconSize.Small,
  svg: ReceiptPrinterSmall
} as const

export const IconReceiptPrinterMedium = {
  name: "ReceiptPrinter",
  size: IconSize.Medium,
  svg: ReceiptPrinterMedium
} as const

export const IconStandardPrinterFilledSmall = {
  name: "StandardPrinterFilled",
  size: IconSize.Small,
  svg: StandardPrinterFilledSmall
} as const

export const IconStandardPrinterFilledMedium = {
  name: "StandardPrinterFilled",
  size: IconSize.Medium,
  svg: StandardPrinterFilledMedium
} as const

export const IconStandardPrinterExtraLarge = {
  name: "StandardPrinter",
  size: IconSize.ExtraLarge,
  svg: StandardPrinterExtraLarge
} as const

export const IconStandardPrinterLarge = {
  name: "StandardPrinter",
  size: IconSize.Large,
  svg: StandardPrinterLarge
} as const

export const IconStandardPrinterSmall = {
  name: "StandardPrinter",
  size: IconSize.Small,
  svg: StandardPrinterSmall
} as const

export const IconStandardPrinterMedium = {
  name: "StandardPrinter",
  size: IconSize.Medium,
  svg: StandardPrinterMedium
} as const

export const IconTabletExtraLarge = {
  name: "Tablet",
  size: IconSize.ExtraLarge,
  svg: TabletExtraLarge
} as const

export const IconTabletLarge = {
  name: "Tablet",
  size: IconSize.Large,
  svg: TabletLarge
} as const

export const IconTabletSmall = {
  name: "Tablet",
  size: IconSize.Small,
  svg: TabletSmall
} as const

export const IconTabletMedium = {
  name: "Tablet",
  size: IconSize.Medium,
  svg: TabletMedium
} as const

export const IconTerminalDockMedium = {
  name: "TerminalDock",
  size: IconSize.Medium,
  svg: TerminalDockMedium
} as const

export const IconTerminalMedium = {
  name: "Terminal",
  size: IconSize.Medium,
  svg: TerminalMedium
} as const

export const IconUsbCableExtraLarge = {
  name: "UsbCable",
  size: IconSize.ExtraLarge,
  svg: UsbCableExtraLarge
} as const

export const IconUsbCableLarge = {
  name: "UsbCable",
  size: IconSize.Large,
  svg: UsbCableLarge
} as const

export const IconUsbCableSmall = {
  name: "UsbCable",
  size: IconSize.Small,
  svg: UsbCableSmall
} as const

export const IconUsbCableMedium = {
  name: "UsbCable",
  size: IconSize.Medium,
  svg: UsbCableMedium
} as const

export const IconWifiDisabledExtraLarge = {
  name: "WifiDisabled",
  size: IconSize.ExtraLarge,
  svg: WifiDisabledExtraLarge
} as const

export const IconWifiDisabledLarge = {
  name: "WifiDisabled",
  size: IconSize.Large,
  svg: WifiDisabledLarge
} as const

export const IconWifiDisabledSmall = {
  name: "WifiDisabled",
  size: IconSize.Small,
  svg: WifiDisabledSmall
} as const

export const IconWifiDisabledMedium = {
  name: "WifiDisabled",
  size: IconSize.Medium,
  svg: WifiDisabledMedium
} as const

export const IconWifiExtraLarge = {
  name: "Wifi",
  size: IconSize.ExtraLarge,
  svg: WifiExtraLarge
} as const

export const IconWifiLarge = {
  name: "Wifi",
  size: IconSize.Large,
  svg: WifiLarge
} as const

export const IconWifiSmall = {
  name: "Wifi",
  size: IconSize.Small,
  svg: WifiSmall
} as const

export const IconWifiMedium = {
  name: "Wifi",
  size: IconSize.Medium,
  svg: WifiMedium
} as const

export const IconAlipayMedium = {
  name: "Alipay",
  size: IconSize.Medium,
  svg: AlipayMedium
} as const

export const IconAmexMedium = {
  name: "Amex",
  size: IconSize.Medium,
  svg: AmexMedium
} as const

export const IconAndroidMedium = {
  name: "Android",
  size: IconSize.Medium,
  svg: AndroidMedium
} as const

export const IconAndroidPayMedium = {
  name: "AndroidPay",
  size: IconSize.Medium,
  svg: AndroidPayMedium
} as const

export const IconAppleMedium = {
  name: "Apple",
  size: IconSize.Medium,
  svg: AppleMedium
} as const

export const IconApplePayMedium = {
  name: "ApplePay",
  size: IconSize.Medium,
  svg: ApplePayMedium
} as const

export const IconBluetoothMedium = {
  name: "Bluetooth",
  size: IconSize.Medium,
  svg: BluetoothMedium
} as const

export const IconCarnetMedium = {
  name: "Carnet",
  size: IconSize.Medium,
  svg: CarnetMedium
} as const

export const IconCartebleueMedium = {
  name: "Cartebleue",
  size: IconSize.Medium,
  svg: CartebleueMedium
} as const

export const IconContactlessMedium = {
  name: "Contactless",
  size: IconSize.Medium,
  svg: ContactlessMedium
} as const

export const IconDinersMedium = {
  name: "Diners",
  size: IconSize.Medium,
  svg: DinersMedium
} as const

export const IconDiscoverMedium = {
  name: "Discover",
  size: IconSize.Medium,
  svg: DiscoverMedium
} as const

export const IconEcMedium = {
  name: "Ec",
  size: IconSize.Medium,
  svg: EcMedium
} as const

export const IconElectronMedium = {
  name: "Electron",
  size: IconSize.Medium,
  svg: ElectronMedium
} as const

export const IconEloMedium = {
  name: "Elo",
  size: IconSize.Medium,
  svg: EloMedium
} as const

export const IconElvMedium = {
  name: "Elv",
  size: IconSize.Medium,
  svg: ElvMedium
} as const

export const IconGpayMedium = {
  name: "Gpay",
  size: IconSize.Medium,
  svg: GpayMedium
} as const

export const IconHiperMedium = {
  name: "Hiper",
  size: IconSize.Medium,
  svg: HiperMedium
} as const

export const IconHipercardMedium = {
  name: "Hipercard",
  size: IconSize.Medium,
  svg: HipercardMedium
} as const

export const IconJcbMedium = {
  name: "Jcb",
  size: IconSize.Medium,
  svg: JcbMedium
} as const

export const IconKlarnaMedium = {
  name: "Klarna",
  size: IconSize.Medium,
  svg: KlarnaMedium
} as const

export const IconMaestroMedium = {
  name: "Maestro",
  size: IconSize.Medium,
  svg: MaestroMedium
} as const

export const IconMastercardFullMedium = {
  name: "MastercardFull",
  size: IconSize.Medium,
  svg: MastercardFullMedium
} as const

export const IconMastercardMedium = {
  name: "Mastercard",
  size: IconSize.Medium,
  svg: MastercardMedium
} as const

export const IconMobilepayMedium = {
  name: "Mobilepay",
  size: IconSize.Medium,
  svg: MobilepayMedium
} as const

export const IconNfcMedium = {
  name: "Nfc",
  size: IconSize.Medium,
  svg: NfcMedium
} as const

export const IconPaypalMedium = {
  name: "Paypal",
  size: IconSize.Medium,
  svg: PaypalMedium
} as const

export const IconSamsungPayMedium = {
  name: "SamsungPay",
  size: IconSize.Medium,
  svg: SamsungPayMedium
} as const

export const IconSkatterverketMedium = {
  name: "Skatterverket",
  size: IconSize.Medium,
  svg: SkatterverketMedium
} as const

export const IconSwishMedium = {
  name: "Swish",
  size: IconSize.Medium,
  svg: SwishMedium
} as const

export const IconUnionpayMedium = {
  name: "Unionpay",
  size: IconSize.Medium,
  svg: UnionpayMedium
} as const

export const IconVenmoMedium = {
  name: "Venmo",
  size: IconSize.Medium,
  svg: VenmoMedium
} as const

export const IconVippsMedium = {
  name: "Vipps",
  size: IconSize.Medium,
  svg: VippsMedium
} as const

export const IconVisaMedium = {
  name: "Visa",
  size: IconSize.Medium,
  svg: VisaMedium
} as const

export const IconVpayMedium = {
  name: "Vpay",
  size: IconSize.Medium,
  svg: VpayMedium
} as const

export const IconWechatMedium = {
  name: "Wechat",
  size: IconSize.Medium,
  svg: WechatMedium
} as const

export const IconZettleIconMedium = {
  name: "ZettleIcon",
  size: IconSize.Medium,
  svg: ZettleIconMedium
} as const

export const IconZettleMedium = {
  name: "Zettle",
  size: IconSize.Medium,
  svg: ZettleMedium
} as const

export const IconZettleNegativeMedium = {
  name: "ZettleNegative",
  size: IconSize.Medium,
  svg: ZettleNegativeMedium
} as const

export const IconZettleZMedium = {
  name: "ZettleZ",
  size: IconSize.Medium,
  svg: ZettleZMedium
} as const

export const IconArrowDownExtraLarge = {
  name: "ArrowDown",
  size: IconSize.ExtraLarge,
  svg: ArrowDownExtraLarge
} as const

export const IconArrowDownLarge = {
  name: "ArrowDown",
  size: IconSize.Large,
  svg: ArrowDownLarge
} as const

export const IconArrowDownExtraSmall = {
  name: "ArrowDown",
  size: IconSize.ExtraSmall,
  svg: ArrowDownExtraSmall
} as const

export const IconArrowDownSmall = {
  name: "ArrowDown",
  size: IconSize.Small,
  svg: ArrowDownSmall
} as const

export const IconArrowDownMedium = {
  name: "ArrowDown",
  size: IconSize.Medium,
  svg: ArrowDownMedium
} as const

export const IconArrowLeftExtraLarge = {
  name: "ArrowLeft",
  size: IconSize.ExtraLarge,
  svg: ArrowLeftExtraLarge
} as const

export const IconArrowLeftLarge = {
  name: "ArrowLeft",
  size: IconSize.Large,
  svg: ArrowLeftLarge
} as const

export const IconArrowLeftExtraSmall = {
  name: "ArrowLeft",
  size: IconSize.ExtraSmall,
  svg: ArrowLeftExtraSmall
} as const

export const IconArrowLeftSmall = {
  name: "ArrowLeft",
  size: IconSize.Small,
  svg: ArrowLeftSmall
} as const

export const IconArrowLeftMedium = {
  name: "ArrowLeft",
  size: IconSize.Medium,
  svg: ArrowLeftMedium
} as const

export const IconArrowRightExtraLarge = {
  name: "ArrowRight",
  size: IconSize.ExtraLarge,
  svg: ArrowRightExtraLarge
} as const

export const IconArrowRightLarge = {
  name: "ArrowRight",
  size: IconSize.Large,
  svg: ArrowRightLarge
} as const

export const IconArrowRightExtraSmall = {
  name: "ArrowRight",
  size: IconSize.ExtraSmall,
  svg: ArrowRightExtraSmall
} as const

export const IconArrowRightSmall = {
  name: "ArrowRight",
  size: IconSize.Small,
  svg: ArrowRightSmall
} as const

export const IconArrowRightMedium = {
  name: "ArrowRight",
  size: IconSize.Medium,
  svg: ArrowRightMedium
} as const

export const IconArrowUpExtraLarge = {
  name: "ArrowUp",
  size: IconSize.ExtraLarge,
  svg: ArrowUpExtraLarge
} as const

export const IconArrowUpLarge = {
  name: "ArrowUp",
  size: IconSize.Large,
  svg: ArrowUpLarge
} as const

export const IconArrowUpExtraSmall = {
  name: "ArrowUp",
  size: IconSize.ExtraSmall,
  svg: ArrowUpExtraSmall
} as const

export const IconArrowUpSmall = {
  name: "ArrowUp",
  size: IconSize.Small,
  svg: ArrowUpSmall
} as const

export const IconArrowUpMedium = {
  name: "ArrowUp",
  size: IconSize.Medium,
  svg: ArrowUpMedium
} as const

export const IconBarDiagramExtraLarge = {
  name: "BarDiagram",
  size: IconSize.ExtraLarge,
  svg: BarDiagramExtraLarge
} as const

export const IconBarDiagramLarge = {
  name: "BarDiagram",
  size: IconSize.Large,
  svg: BarDiagramLarge
} as const

export const IconBarDiagramSmall = {
  name: "BarDiagram",
  size: IconSize.Small,
  svg: BarDiagramSmall
} as const

export const IconBarDiagramMedium = {
  name: "BarDiagram",
  size: IconSize.Medium,
  svg: BarDiagramMedium
} as const

export const IconCrossExtraLarge = {
  name: "Cross",
  size: IconSize.ExtraLarge,
  svg: CrossExtraLarge
} as const

export const IconCrossLarge = {
  name: "Cross",
  size: IconSize.Large,
  svg: CrossLarge
} as const

export const IconCrossExtraSmall = {
  name: "Cross",
  size: IconSize.ExtraSmall,
  svg: CrossExtraSmall
} as const

export const IconCrossSmall = {
  name: "Cross",
  size: IconSize.Small,
  svg: CrossSmall
} as const

export const IconCrossMedium = {
  name: "Cross",
  size: IconSize.Medium,
  svg: CrossMedium
} as const

export const IconDownloadExtraLarge = {
  name: "Download",
  size: IconSize.ExtraLarge,
  svg: DownloadExtraLarge
} as const

export const IconDownloadLarge = {
  name: "Download",
  size: IconSize.Large,
  svg: DownloadLarge
} as const

export const IconDownloadSmall = {
  name: "Download",
  size: IconSize.Small,
  svg: DownloadSmall
} as const

export const IconDownloadMedium = {
  name: "Download",
  size: IconSize.Medium,
  svg: DownloadMedium
} as const

export const IconExportExtraLarge = {
  name: "Export",
  size: IconSize.ExtraLarge,
  svg: ExportExtraLarge
} as const

export const IconExportLarge = {
  name: "Export",
  size: IconSize.Large,
  svg: ExportLarge
} as const

export const IconExportSmall = {
  name: "Export",
  size: IconSize.Small,
  svg: ExportSmall
} as const

export const IconExportMedium = {
  name: "Export",
  size: IconSize.Medium,
  svg: ExportMedium
} as const

export const IconImportExtraLarge = {
  name: "Import",
  size: IconSize.ExtraLarge,
  svg: ImportExtraLarge
} as const

export const IconImportLarge = {
  name: "Import",
  size: IconSize.Large,
  svg: ImportLarge
} as const

export const IconImportSmall = {
  name: "Import",
  size: IconSize.Small,
  svg: ImportSmall
} as const

export const IconImportMedium = {
  name: "Import",
  size: IconSize.Medium,
  svg: ImportMedium
} as const

export const IconMenuExtraLarge = {
  name: "Menu",
  size: IconSize.ExtraLarge,
  svg: MenuExtraLarge
} as const

export const IconMenuLarge = {
  name: "Menu",
  size: IconSize.Large,
  svg: MenuLarge
} as const

export const IconMenuSmall = {
  name: "Menu",
  size: IconSize.Small,
  svg: MenuSmall
} as const

export const IconMenuMedium = {
  name: "Menu",
  size: IconSize.Medium,
  svg: MenuMedium
} as const

export const IconMinusExtraLarge = {
  name: "Minus",
  size: IconSize.ExtraLarge,
  svg: MinusExtraLarge
} as const

export const IconMinusLarge = {
  name: "Minus",
  size: IconSize.Large,
  svg: MinusLarge
} as const

export const IconMinusExtraSmall = {
  name: "Minus",
  size: IconSize.ExtraSmall,
  svg: MinusExtraSmall
} as const

export const IconMinusSmall = {
  name: "Minus",
  size: IconSize.Small,
  svg: MinusSmall
} as const

export const IconMinusMedium = {
  name: "Minus",
  size: IconSize.Medium,
  svg: MinusMedium
} as const

export const IconMoreExtraLarge = {
  name: "More",
  size: IconSize.ExtraLarge,
  svg: MoreExtraLarge
} as const

export const IconMoreLarge = {
  name: "More",
  size: IconSize.Large,
  svg: MoreLarge
} as const

export const IconMoreSmall = {
  name: "More",
  size: IconSize.Small,
  svg: MoreSmall
} as const

export const IconMoreMedium = {
  name: "More",
  size: IconSize.Medium,
  svg: MoreMedium
} as const

export const IconPercentExtraLarge = {
  name: "Percent",
  size: IconSize.ExtraLarge,
  svg: PercentExtraLarge
} as const

export const IconPercentLarge = {
  name: "Percent",
  size: IconSize.Large,
  svg: PercentLarge
} as const

export const IconPercentSmall = {
  name: "Percent",
  size: IconSize.Small,
  svg: PercentSmall
} as const

export const IconPercentMedium = {
  name: "Percent",
  size: IconSize.Medium,
  svg: PercentMedium
} as const

export const IconPlusExtraLarge = {
  name: "Plus",
  size: IconSize.ExtraLarge,
  svg: PlusExtraLarge
} as const

export const IconPlusLarge = {
  name: "Plus",
  size: IconSize.Large,
  svg: PlusLarge
} as const

export const IconPlusExtraSmall = {
  name: "Plus",
  size: IconSize.ExtraSmall,
  svg: PlusExtraSmall
} as const

export const IconPlusSmall = {
  name: "Plus",
  size: IconSize.Small,
  svg: PlusSmall
} as const

export const IconPlusMedium = {
  name: "Plus",
  size: IconSize.Medium,
  svg: PlusMedium
} as const

export const IconReloadExtraLarge = {
  name: "Reload",
  size: IconSize.ExtraLarge,
  svg: ReloadExtraLarge
} as const

export const IconReloadLarge = {
  name: "Reload",
  size: IconSize.Large,
  svg: ReloadLarge
} as const

export const IconReloadExtraSmall = {
  name: "Reload",
  size: IconSize.ExtraSmall,
  svg: ReloadExtraSmall
} as const

export const IconReloadSmall = {
  name: "Reload",
  size: IconSize.Small,
  svg: ReloadSmall
} as const

export const IconReloadMedium = {
  name: "Reload",
  size: IconSize.Medium,
  svg: ReloadMedium
} as const

export const IconRevertExtraLarge = {
  name: "Revert",
  size: IconSize.ExtraLarge,
  svg: RevertExtraLarge
} as const

export const IconRevertLarge = {
  name: "Revert",
  size: IconSize.Large,
  svg: RevertLarge
} as const

export const IconRevertExtraSmall = {
  name: "Revert",
  size: IconSize.ExtraSmall,
  svg: RevertExtraSmall
} as const

export const IconRevertSmall = {
  name: "Revert",
  size: IconSize.Small,
  svg: RevertSmall
} as const

export const IconRevertMedium = {
  name: "Revert",
  size: IconSize.Medium,
  svg: RevertMedium
} as const

export const IconSimpleArrowDownExtraLarge = {
  name: "SimpleArrowDown",
  size: IconSize.ExtraLarge,
  svg: SimpleArrowDownExtraLarge
} as const

export const IconSimpleArrowDownLarge = {
  name: "SimpleArrowDown",
  size: IconSize.Large,
  svg: SimpleArrowDownLarge
} as const

export const IconSimpleArrowDownExtraSmall = {
  name: "SimpleArrowDown",
  size: IconSize.ExtraSmall,
  svg: SimpleArrowDownExtraSmall
} as const

export const IconSimpleArrowDownSmall = {
  name: "SimpleArrowDown",
  size: IconSize.Small,
  svg: SimpleArrowDownSmall
} as const

export const IconSimpleArrowDownMedium = {
  name: "SimpleArrowDown",
  size: IconSize.Medium,
  svg: SimpleArrowDownMedium
} as const

export const IconSimpleArrowLeftExtraLarge = {
  name: "SimpleArrowLeft",
  size: IconSize.ExtraLarge,
  svg: SimpleArrowLeftExtraLarge
} as const

export const IconSimpleArrowLeftLarge = {
  name: "SimpleArrowLeft",
  size: IconSize.Large,
  svg: SimpleArrowLeftLarge
} as const

export const IconSimpleArrowLeftExtraSmall = {
  name: "SimpleArrowLeft",
  size: IconSize.ExtraSmall,
  svg: SimpleArrowLeftExtraSmall
} as const

export const IconSimpleArrowLeftSmall = {
  name: "SimpleArrowLeft",
  size: IconSize.Small,
  svg: SimpleArrowLeftSmall
} as const

export const IconSimpleArrowLeftMedium = {
  name: "SimpleArrowLeft",
  size: IconSize.Medium,
  svg: SimpleArrowLeftMedium
} as const

export const IconSimpleArrowRightExtraLarge = {
  name: "SimpleArrowRight",
  size: IconSize.ExtraLarge,
  svg: SimpleArrowRightExtraLarge
} as const

export const IconSimpleArrowRightLarge = {
  name: "SimpleArrowRight",
  size: IconSize.Large,
  svg: SimpleArrowRightLarge
} as const

export const IconSimpleArrowRightExtraSmall = {
  name: "SimpleArrowRight",
  size: IconSize.ExtraSmall,
  svg: SimpleArrowRightExtraSmall
} as const

export const IconSimpleArrowRightSmall = {
  name: "SimpleArrowRight",
  size: IconSize.Small,
  svg: SimpleArrowRightSmall
} as const

export const IconSimpleArrowRightMedium = {
  name: "SimpleArrowRight",
  size: IconSize.Medium,
  svg: SimpleArrowRightMedium
} as const

export const IconSimpleArrowUpExtraLarge = {
  name: "SimpleArrowUp",
  size: IconSize.ExtraLarge,
  svg: SimpleArrowUpExtraLarge
} as const

export const IconSimpleArrowUpLarge = {
  name: "SimpleArrowUp",
  size: IconSize.Large,
  svg: SimpleArrowUpLarge
} as const

export const IconSimpleArrowUpExtraSmall = {
  name: "SimpleArrowUp",
  size: IconSize.ExtraSmall,
  svg: SimpleArrowUpExtraSmall
} as const

export const IconSimpleArrowUpSmall = {
  name: "SimpleArrowUp",
  size: IconSize.Small,
  svg: SimpleArrowUpSmall
} as const

export const IconSimpleArrowUpMedium = {
  name: "SimpleArrowUp",
  size: IconSize.Medium,
  svg: SimpleArrowUpMedium
} as const

export const IconSortDownExtraLarge = {
  name: "SortDown",
  size: IconSize.ExtraLarge,
  svg: SortDownExtraLarge
} as const

export const IconSortDownLarge = {
  name: "SortDown",
  size: IconSize.Large,
  svg: SortDownLarge
} as const

export const IconSortDownExtraSmall = {
  name: "SortDown",
  size: IconSize.ExtraSmall,
  svg: SortDownExtraSmall
} as const

export const IconSortDownSmall = {
  name: "SortDown",
  size: IconSize.Small,
  svg: SortDownSmall
} as const

export const IconSortDownMedium = {
  name: "SortDown",
  size: IconSize.Medium,
  svg: SortDownMedium
} as const

export const IconSortUpExtraLarge = {
  name: "SortUp",
  size: IconSize.ExtraLarge,
  svg: SortUpExtraLarge
} as const

export const IconSortUpLarge = {
  name: "SortUp",
  size: IconSize.Large,
  svg: SortUpLarge
} as const

export const IconSortUpExtraSmall = {
  name: "SortUp",
  size: IconSize.ExtraSmall,
  svg: SortUpExtraSmall
} as const

export const IconSortUpSmall = {
  name: "SortUp",
  size: IconSize.Small,
  svg: SortUpSmall
} as const

export const IconSortUpMedium = {
  name: "SortUp",
  size: IconSize.Medium,
  svg: SortUpMedium
} as const

export const IconTickExtraLarge = {
  name: "Tick",
  size: IconSize.ExtraLarge,
  svg: TickExtraLarge
} as const

export const IconTickLarge = {
  name: "Tick",
  size: IconSize.Large,
  svg: TickLarge
} as const

export const IconTickExtraSmall = {
  name: "Tick",
  size: IconSize.ExtraSmall,
  svg: TickExtraSmall
} as const

export const IconTickSmall = {
  name: "Tick",
  size: IconSize.Small,
  svg: TickSmall
} as const

export const IconTickMedium = {
  name: "Tick",
  size: IconSize.Medium,
  svg: TickMedium
} as const

export const IconUndoExtraLarge = {
  name: "Undo",
  size: IconSize.ExtraLarge,
  svg: UndoExtraLarge
} as const

export const IconUndoLarge = {
  name: "Undo",
  size: IconSize.Large,
  svg: UndoLarge
} as const

export const IconUndoExtraSmall = {
  name: "Undo",
  size: IconSize.ExtraSmall,
  svg: UndoExtraSmall
} as const

export const IconUndoSmall = {
  name: "Undo",
  size: IconSize.Small,
  svg: UndoSmall
} as const

export const IconUndoMedium = {
  name: "Undo",
  size: IconSize.Medium,
  svg: UndoMedium
} as const

export const IconOneTwoThreeFilledSmall = {
  name: "OneTwoThreeFilled",
  size: IconSize.Small,
  svg: OneTwoThreeFilledSmall
} as const

export const IconOneTwoThreeFilledMedium = {
  name: "OneTwoThreeFilled",
  size: IconSize.Medium,
  svg: OneTwoThreeFilledMedium
} as const

export const IconOneTwoThreeExtraLarge = {
  name: "OneTwoThree",
  size: IconSize.ExtraLarge,
  svg: OneTwoThreeExtraLarge
} as const

export const IconOneTwoThreeLarge = {
  name: "OneTwoThree",
  size: IconSize.Large,
  svg: OneTwoThreeLarge
} as const

export const IconOneTwoThreeSmall = {
  name: "OneTwoThree",
  size: IconSize.Small,
  svg: OneTwoThreeSmall
} as const

export const IconOneTwoThreeMedium = {
  name: "OneTwoThree",
  size: IconSize.Medium,
  svg: OneTwoThreeMedium
} as const

export const IconAccessibilityMedium = {
  name: "Accessibility",
  size: IconSize.Medium,
  svg: AccessibilityMedium
} as const

export const IconAppsSystemUpdateMedium = {
  name: "AppsSystemUpdate",
  size: IconSize.Medium,
  svg: AppsSystemUpdateMedium
} as const

export const IconBackspaceFilledSmall = {
  name: "BackspaceFilled",
  size: IconSize.Small,
  svg: BackspaceFilledSmall
} as const

export const IconBackspaceFilledMedium = {
  name: "BackspaceFilled",
  size: IconSize.Medium,
  svg: BackspaceFilledMedium
} as const

export const IconBackspaceExtraLarge = {
  name: "Backspace",
  size: IconSize.ExtraLarge,
  svg: BackspaceExtraLarge
} as const

export const IconBackspaceLarge = {
  name: "Backspace",
  size: IconSize.Large,
  svg: BackspaceLarge
} as const

export const IconBackspaceSmall = {
  name: "Backspace",
  size: IconSize.Small,
  svg: BackspaceSmall
} as const

export const IconBackspaceMedium = {
  name: "Backspace",
  size: IconSize.Medium,
  svg: BackspaceMedium
} as const

export const IconBankFilledSmall = {
  name: "BankFilled",
  size: IconSize.Small,
  svg: BankFilledSmall
} as const

export const IconBankFilledMedium = {
  name: "BankFilled",
  size: IconSize.Medium,
  svg: BankFilledMedium
} as const

export const IconBankExtraLarge = {
  name: "Bank",
  size: IconSize.ExtraLarge,
  svg: BankExtraLarge
} as const

export const IconBankLarge = {
  name: "Bank",
  size: IconSize.Large,
  svg: BankLarge
} as const

export const IconBankSmall = {
  name: "Bank",
  size: IconSize.Small,
  svg: BankSmall
} as const

export const IconBankMedium = {
  name: "Bank",
  size: IconSize.Medium,
  svg: BankMedium
} as const

export const IconBarcodeFilledSmall = {
  name: "BarcodeFilled",
  size: IconSize.Small,
  svg: BarcodeFilledSmall
} as const

export const IconBarcodeFilledMedium = {
  name: "BarcodeFilled",
  size: IconSize.Medium,
  svg: BarcodeFilledMedium
} as const

export const IconBarcodeExtraLarge = {
  name: "Barcode",
  size: IconSize.ExtraLarge,
  svg: BarcodeExtraLarge
} as const

export const IconBarcodeLarge = {
  name: "Barcode",
  size: IconSize.Large,
  svg: BarcodeLarge
} as const

export const IconBarcodeSmall = {
  name: "Barcode",
  size: IconSize.Small,
  svg: BarcodeSmall
} as const

export const IconBarcodeMedium = {
  name: "Barcode",
  size: IconSize.Medium,
  svg: BarcodeMedium
} as const

export const IconBarcodeokFilledSmall = {
  name: "BarcodeokFilled",
  size: IconSize.Small,
  svg: BarcodeokFilledSmall
} as const

export const IconBarcodeokFilledMedium = {
  name: "BarcodeokFilled",
  size: IconSize.Medium,
  svg: BarcodeokFilledMedium
} as const

export const IconBarcodeokExtraLarge = {
  name: "Barcodeok",
  size: IconSize.ExtraLarge,
  svg: BarcodeokExtraLarge
} as const

export const IconBarcodeokLarge = {
  name: "Barcodeok",
  size: IconSize.Large,
  svg: BarcodeokLarge
} as const

export const IconBarcodeokSmall = {
  name: "Barcodeok",
  size: IconSize.Small,
  svg: BarcodeokSmall
} as const

export const IconBarcodeokMedium = {
  name: "Barcodeok",
  size: IconSize.Medium,
  svg: BarcodeokMedium
} as const

export const IconBulletlistFilledSmall = {
  name: "BulletlistFilled",
  size: IconSize.Small,
  svg: BulletlistFilledSmall
} as const

export const IconBulletlistFilledMedium = {
  name: "BulletlistFilled",
  size: IconSize.Medium,
  svg: BulletlistFilledMedium
} as const

export const IconBulletlistExtraLarge = {
  name: "Bulletlist",
  size: IconSize.ExtraLarge,
  svg: BulletlistExtraLarge
} as const

export const IconBulletlistLarge = {
  name: "Bulletlist",
  size: IconSize.Large,
  svg: BulletlistLarge
} as const

export const IconBulletlistSmall = {
  name: "Bulletlist",
  size: IconSize.Small,
  svg: BulletlistSmall
} as const

export const IconBulletlistMedium = {
  name: "Bulletlist",
  size: IconSize.Medium,
  svg: BulletlistMedium
} as const

export const IconCardFilledSmall = {
  name: "CardFilled",
  size: IconSize.Small,
  svg: CardFilledSmall
} as const

export const IconCardFilledMedium = {
  name: "CardFilled",
  size: IconSize.Medium,
  svg: CardFilledMedium
} as const

export const IconCardExtraLarge = {
  name: "Card",
  size: IconSize.ExtraLarge,
  svg: CardExtraLarge
} as const

export const IconCardLarge = {
  name: "Card",
  size: IconSize.Large,
  svg: CardLarge
} as const

export const IconCardSmall = {
  name: "Card",
  size: IconSize.Small,
  svg: CardSmall
} as const

export const IconCardMedium = {
  name: "Card",
  size: IconSize.Medium,
  svg: CardMedium
} as const

export const IconCardOverPhoneExtraLarge = {
  name: "CardOverPhone",
  size: IconSize.ExtraLarge,
  svg: CardOverPhoneExtraLarge
} as const

export const IconCardOverPhoneLarge = {
  name: "CardOverPhone",
  size: IconSize.Large,
  svg: CardOverPhoneLarge
} as const

export const IconCardOverPhoneSmall = {
  name: "CardOverPhone",
  size: IconSize.Small,
  svg: CardOverPhoneSmall
} as const

export const IconCardOverPhoneMedium = {
  name: "CardOverPhone",
  size: IconSize.Medium,
  svg: CardOverPhoneMedium
} as const

export const IconCashFilledSmall = {
  name: "CashFilled",
  size: IconSize.Small,
  svg: CashFilledSmall
} as const

export const IconCashFilledMedium = {
  name: "CashFilled",
  size: IconSize.Medium,
  svg: CashFilledMedium
} as const

export const IconCashExtraLarge = {
  name: "Cash",
  size: IconSize.ExtraLarge,
  svg: CashExtraLarge
} as const

export const IconCashLarge = {
  name: "Cash",
  size: IconSize.Large,
  svg: CashLarge
} as const

export const IconCashSmall = {
  name: "Cash",
  size: IconSize.Small,
  svg: CashSmall
} as const

export const IconCashMedium = {
  name: "Cash",
  size: IconSize.Medium,
  svg: CashMedium
} as const

export const IconChatFilledSmall = {
  name: "ChatFilled",
  size: IconSize.Small,
  svg: ChatFilledSmall
} as const

export const IconChatFilledMedium = {
  name: "ChatFilled",
  size: IconSize.Medium,
  svg: ChatFilledMedium
} as const

export const IconChatExtraLarge = {
  name: "Chat",
  size: IconSize.ExtraLarge,
  svg: ChatExtraLarge
} as const

export const IconChatLarge = {
  name: "Chat",
  size: IconSize.Large,
  svg: ChatLarge
} as const

export const IconChatSmall = {
  name: "Chat",
  size: IconSize.Small,
  svg: ChatSmall
} as const

export const IconChatMedium = {
  name: "Chat",
  size: IconSize.Medium,
  svg: ChatMedium
} as const

export const IconChipFilledSmall = {
  name: "ChipFilled",
  size: IconSize.Small,
  svg: ChipFilledSmall
} as const

export const IconChipFilledMedium = {
  name: "ChipFilled",
  size: IconSize.Medium,
  svg: ChipFilledMedium
} as const

export const IconChipExtraLarge = {
  name: "Chip",
  size: IconSize.ExtraLarge,
  svg: ChipExtraLarge
} as const

export const IconChipLarge = {
  name: "Chip",
  size: IconSize.Large,
  svg: ChipLarge
} as const

export const IconChipSmall = {
  name: "Chip",
  size: IconSize.Small,
  svg: ChipSmall
} as const

export const IconChipMedium = {
  name: "Chip",
  size: IconSize.Medium,
  svg: ChipMedium
} as const

export const IconCloudFilledSmall = {
  name: "CloudFilled",
  size: IconSize.Small,
  svg: CloudFilledSmall
} as const

export const IconCloudFilledMedium = {
  name: "CloudFilled",
  size: IconSize.Medium,
  svg: CloudFilledMedium
} as const

export const IconCloudExtraLarge = {
  name: "Cloud",
  size: IconSize.ExtraLarge,
  svg: CloudExtraLarge
} as const

export const IconCloudLarge = {
  name: "Cloud",
  size: IconSize.Large,
  svg: CloudLarge
} as const

export const IconCloudSmall = {
  name: "Cloud",
  size: IconSize.Small,
  svg: CloudSmall
} as const

export const IconCloudMedium = {
  name: "Cloud",
  size: IconSize.Medium,
  svg: CloudMedium
} as const

export const IconCogFilledExtraSmall = {
  name: "CogFilled",
  size: IconSize.ExtraSmall,
  svg: CogFilledExtraSmall
} as const

export const IconCogFilledSmall = {
  name: "CogFilled",
  size: IconSize.Small,
  svg: CogFilledSmall
} as const

export const IconCogFilledMedium = {
  name: "CogFilled",
  size: IconSize.Medium,
  svg: CogFilledMedium
} as const

export const IconCogExtraLarge = {
  name: "Cog",
  size: IconSize.ExtraLarge,
  svg: CogExtraLarge
} as const

export const IconCogLarge = {
  name: "Cog",
  size: IconSize.Large,
  svg: CogLarge
} as const

export const IconCogExtraSmall = {
  name: "Cog",
  size: IconSize.ExtraSmall,
  svg: CogExtraSmall
} as const

export const IconCogSmall = {
  name: "Cog",
  size: IconSize.Small,
  svg: CogSmall
} as const

export const IconCogMedium = {
  name: "Cog",
  size: IconSize.Medium,
  svg: CogMedium
} as const

export const IconCopyClipboardExtraLarge = {
  name: "CopyClipboard",
  size: IconSize.ExtraLarge,
  svg: CopyClipboardExtraLarge
} as const

export const IconCopyClipboardLarge = {
  name: "CopyClipboard",
  size: IconSize.Large,
  svg: CopyClipboardLarge
} as const

export const IconCopyClipboardSmall = {
  name: "CopyClipboard",
  size: IconSize.Small,
  svg: CopyClipboardSmall
} as const

export const IconCopyClipboardMedium = {
  name: "CopyClipboard",
  size: IconSize.Medium,
  svg: CopyClipboardMedium
} as const

export const IconDateFilledSmall = {
  name: "DateFilled",
  size: IconSize.Small,
  svg: DateFilledSmall
} as const

export const IconDateFilledMedium = {
  name: "DateFilled",
  size: IconSize.Medium,
  svg: DateFilledMedium
} as const

export const IconDateExtraLarge = {
  name: "Date",
  size: IconSize.ExtraLarge,
  svg: DateExtraLarge
} as const

export const IconDateLarge = {
  name: "Date",
  size: IconSize.Large,
  svg: DateLarge
} as const

export const IconDateExtraSmall = {
  name: "Date",
  size: IconSize.ExtraSmall,
  svg: DateExtraSmall
} as const

export const IconDateSmall = {
  name: "Date",
  size: IconSize.Small,
  svg: DateSmall
} as const

export const IconDateMedium = {
  name: "Date",
  size: IconSize.Medium,
  svg: DateMedium
} as const

export const IconDeliveryFilledSmall = {
  name: "DeliveryFilled",
  size: IconSize.Small,
  svg: DeliveryFilledSmall
} as const

export const IconDeliveryFilledMedium = {
  name: "DeliveryFilled",
  size: IconSize.Medium,
  svg: DeliveryFilledMedium
} as const

export const IconDeliveryExtraLarge = {
  name: "Delivery",
  size: IconSize.ExtraLarge,
  svg: DeliveryExtraLarge
} as const

export const IconDeliveryLarge = {
  name: "Delivery",
  size: IconSize.Large,
  svg: DeliveryLarge
} as const

export const IconDeliverySmall = {
  name: "Delivery",
  size: IconSize.Small,
  svg: DeliverySmall
} as const

export const IconDeliveryMedium = {
  name: "Delivery",
  size: IconSize.Medium,
  svg: DeliveryMedium
} as const

export const IconDepositFilledSmall = {
  name: "DepositFilled",
  size: IconSize.Small,
  svg: DepositFilledSmall
} as const

export const IconDepositFilledMedium = {
  name: "DepositFilled",
  size: IconSize.Medium,
  svg: DepositFilledMedium
} as const

export const IconDepositExtraLarge = {
  name: "Deposit",
  size: IconSize.ExtraLarge,
  svg: DepositExtraLarge
} as const

export const IconDepositLarge = {
  name: "Deposit",
  size: IconSize.Large,
  svg: DepositLarge
} as const

export const IconDepositSmall = {
  name: "Deposit",
  size: IconSize.Small,
  svg: DepositSmall
} as const

export const IconDepositMedium = {
  name: "Deposit",
  size: IconSize.Medium,
  svg: DepositMedium
} as const

export const IconEcommerceFilledSmall = {
  name: "EcommerceFilled",
  size: IconSize.Small,
  svg: EcommerceFilledSmall
} as const

export const IconEcommerceFilledMedium = {
  name: "EcommerceFilled",
  size: IconSize.Medium,
  svg: EcommerceFilledMedium
} as const

export const IconEcommerceExtraLarge = {
  name: "Ecommerce",
  size: IconSize.ExtraLarge,
  svg: EcommerceExtraLarge
} as const

export const IconEcommerceLarge = {
  name: "Ecommerce",
  size: IconSize.Large,
  svg: EcommerceLarge
} as const

export const IconEcommerceSmall = {
  name: "Ecommerce",
  size: IconSize.Small,
  svg: EcommerceSmall
} as const

export const IconEcommerceMedium = {
  name: "Ecommerce",
  size: IconSize.Medium,
  svg: EcommerceMedium
} as const

export const IconEditFilledSmall = {
  name: "EditFilled",
  size: IconSize.Small,
  svg: EditFilledSmall
} as const

export const IconEditFilledMedium = {
  name: "EditFilled",
  size: IconSize.Medium,
  svg: EditFilledMedium
} as const

export const IconEditExtraLarge = {
  name: "Edit",
  size: IconSize.ExtraLarge,
  svg: EditExtraLarge
} as const

export const IconEditLarge = {
  name: "Edit",
  size: IconSize.Large,
  svg: EditLarge
} as const

export const IconEditExtraSmall = {
  name: "Edit",
  size: IconSize.ExtraSmall,
  svg: EditExtraSmall
} as const

export const IconEditSmall = {
  name: "Edit",
  size: IconSize.Small,
  svg: EditSmall
} as const

export const IconEditMedium = {
  name: "Edit",
  size: IconSize.Medium,
  svg: EditMedium
} as const

export const IconEmailFilledSmall = {
  name: "EmailFilled",
  size: IconSize.Small,
  svg: EmailFilledSmall
} as const

export const IconEmailFilledMedium = {
  name: "EmailFilled",
  size: IconSize.Medium,
  svg: EmailFilledMedium
} as const

export const IconEmailExtraLarge = {
  name: "Email",
  size: IconSize.ExtraLarge,
  svg: EmailExtraLarge
} as const

export const IconEmailLarge = {
  name: "Email",
  size: IconSize.Large,
  svg: EmailLarge
} as const

export const IconEmailSmall = {
  name: "Email",
  size: IconSize.Small,
  svg: EmailSmall
} as const

export const IconEmailMedium = {
  name: "Email",
  size: IconSize.Medium,
  svg: EmailMedium
} as const

export const IconErrorFilledExtraSmall = {
  name: "ErrorFilled",
  size: IconSize.ExtraSmall,
  svg: ErrorFilledExtraSmall
} as const

export const IconErrorFilledSmall = {
  name: "ErrorFilled",
  size: IconSize.Small,
  svg: ErrorFilledSmall
} as const

export const IconErrorFilledMedium = {
  name: "ErrorFilled",
  size: IconSize.Medium,
  svg: ErrorFilledMedium
} as const

export const IconErrorExtraLarge = {
  name: "Error",
  size: IconSize.ExtraLarge,
  svg: ErrorExtraLarge
} as const

export const IconErrorLarge = {
  name: "Error",
  size: IconSize.Large,
  svg: ErrorLarge
} as const

export const IconErrorExtraSmall = {
  name: "Error",
  size: IconSize.ExtraSmall,
  svg: ErrorExtraSmall
} as const

export const IconErrorSmall = {
  name: "Error",
  size: IconSize.Small,
  svg: ErrorSmall
} as const

export const IconErrorMedium = {
  name: "Error",
  size: IconSize.Medium,
  svg: ErrorMedium
} as const

export const IconFilterExtraLarge = {
  name: "Filter",
  size: IconSize.ExtraLarge,
  svg: FilterExtraLarge
} as const

export const IconFilterLarge = {
  name: "Filter",
  size: IconSize.Large,
  svg: FilterLarge
} as const

export const IconFilterExtraSmall = {
  name: "Filter",
  size: IconSize.ExtraSmall,
  svg: FilterExtraSmall
} as const

export const IconFilterSmall = {
  name: "Filter",
  size: IconSize.Small,
  svg: FilterSmall
} as const

export const IconFilterMedium = {
  name: "Filter",
  size: IconSize.Medium,
  svg: FilterMedium
} as const

export const IconFundingFilledSmall = {
  name: "FundingFilled",
  size: IconSize.Small,
  svg: FundingFilledSmall
} as const

export const IconFundingFilledMedium = {
  name: "FundingFilled",
  size: IconSize.Medium,
  svg: FundingFilledMedium
} as const

export const IconFundingExtraLarge = {
  name: "Funding",
  size: IconSize.ExtraLarge,
  svg: FundingExtraLarge
} as const

export const IconFundingLarge = {
  name: "Funding",
  size: IconSize.Large,
  svg: FundingLarge
} as const

export const IconFundingSmall = {
  name: "Funding",
  size: IconSize.Small,
  svg: FundingSmall
} as const

export const IconFundingMedium = {
  name: "Funding",
  size: IconSize.Medium,
  svg: FundingMedium
} as const

export const IconGiftCardExtraLarge = {
  name: "GiftCard",
  size: IconSize.ExtraLarge,
  svg: GiftCardExtraLarge
} as const

export const IconGiftCardLarge = {
  name: "GiftCard",
  size: IconSize.Large,
  svg: GiftCardLarge
} as const

export const IconGiftCardSmall = {
  name: "GiftCard",
  size: IconSize.Small,
  svg: GiftCardSmall
} as const

export const IconGiftCardMedium = {
  name: "GiftCard",
  size: IconSize.Medium,
  svg: GiftCardMedium
} as const

export const IconGridOnex1Large = {
  name: "GridOnex1",
  size: IconSize.Large,
  svg: GridOnex1Large
} as const

export const IconGridTwox2Large = {
  name: "GridTwox2",
  size: IconSize.Large,
  svg: GridTwox2Large
} as const

export const IconGridThreex3Large = {
  name: "GridThreex3",
  size: IconSize.Large,
  svg: GridThreex3Large
} as const

export const IconHeartFilledSmall = {
  name: "HeartFilled",
  size: IconSize.Small,
  svg: HeartFilledSmall
} as const

export const IconHeartFilledMedium = {
  name: "HeartFilled",
  size: IconSize.Medium,
  svg: HeartFilledMedium
} as const

export const IconHeartExtraLarge = {
  name: "Heart",
  size: IconSize.ExtraLarge,
  svg: HeartExtraLarge
} as const

export const IconHeartLarge = {
  name: "Heart",
  size: IconSize.Large,
  svg: HeartLarge
} as const

export const IconHeartExtraSmall = {
  name: "Heart",
  size: IconSize.ExtraSmall,
  svg: HeartExtraSmall
} as const

export const IconHeartSmall = {
  name: "Heart",
  size: IconSize.Small,
  svg: HeartSmall
} as const

export const IconHeartMedium = {
  name: "Heart",
  size: IconSize.Medium,
  svg: HeartMedium
} as const

export const IconHideExtraLarge = {
  name: "Hide",
  size: IconSize.ExtraLarge,
  svg: HideExtraLarge
} as const

export const IconHideLarge = {
  name: "Hide",
  size: IconSize.Large,
  svg: HideLarge
} as const

export const IconHideSmall = {
  name: "Hide",
  size: IconSize.Small,
  svg: HideSmall
} as const

export const IconHideMedium = {
  name: "Hide",
  size: IconSize.Medium,
  svg: HideMedium
} as const

export const IconHidekeyboardFilledSmall = {
  name: "HidekeyboardFilled",
  size: IconSize.Small,
  svg: HidekeyboardFilledSmall
} as const

export const IconHidekeyboardFilledMedium = {
  name: "HidekeyboardFilled",
  size: IconSize.Medium,
  svg: HidekeyboardFilledMedium
} as const

export const IconHidekeyboardExtraLarge = {
  name: "Hidekeyboard",
  size: IconSize.ExtraLarge,
  svg: HidekeyboardExtraLarge
} as const

export const IconHidekeyboardLarge = {
  name: "Hidekeyboard",
  size: IconSize.Large,
  svg: HidekeyboardLarge
} as const

export const IconHidekeyboardSmall = {
  name: "Hidekeyboard",
  size: IconSize.Small,
  svg: HidekeyboardSmall
} as const

export const IconHidekeyboardMedium = {
  name: "Hidekeyboard",
  size: IconSize.Medium,
  svg: HidekeyboardMedium
} as const

export const IconHomeFilledSmall = {
  name: "HomeFilled",
  size: IconSize.Small,
  svg: HomeFilledSmall
} as const

export const IconHomeFilledMedium = {
  name: "HomeFilled",
  size: IconSize.Medium,
  svg: HomeFilledMedium
} as const

export const IconHomeExtraLarge = {
  name: "Home",
  size: IconSize.ExtraLarge,
  svg: HomeExtraLarge
} as const

export const IconHomeLarge = {
  name: "Home",
  size: IconSize.Large,
  svg: HomeLarge
} as const

export const IconHomeSmall = {
  name: "Home",
  size: IconSize.Small,
  svg: HomeSmall
} as const

export const IconHomeMedium = {
  name: "Home",
  size: IconSize.Medium,
  svg: HomeMedium
} as const

export const IconIdCardFilledSmall = {
  name: "IdCardFilled",
  size: IconSize.Small,
  svg: IdCardFilledSmall
} as const

export const IconIdCardFilledMedium = {
  name: "IdCardFilled",
  size: IconSize.Medium,
  svg: IdCardFilledMedium
} as const

export const IconIdCardExtraLarge = {
  name: "IdCard",
  size: IconSize.ExtraLarge,
  svg: IdCardExtraLarge
} as const

export const IconIdCardLarge = {
  name: "IdCard",
  size: IconSize.Large,
  svg: IdCardLarge
} as const

export const IconIdCardSmall = {
  name: "IdCard",
  size: IconSize.Small,
  svg: IdCardSmall
} as const

export const IconIdCardMedium = {
  name: "IdCard",
  size: IconSize.Medium,
  svg: IdCardMedium
} as const

export const IconIdeaFilledSmall = {
  name: "IdeaFilled",
  size: IconSize.Small,
  svg: IdeaFilledSmall
} as const

export const IconIdeaFilledMedium = {
  name: "IdeaFilled",
  size: IconSize.Medium,
  svg: IdeaFilledMedium
} as const

export const IconIdeaExtraLarge = {
  name: "Idea",
  size: IconSize.ExtraLarge,
  svg: IdeaExtraLarge
} as const

export const IconIdeaLarge = {
  name: "Idea",
  size: IconSize.Large,
  svg: IdeaLarge
} as const

export const IconIdeaSmall = {
  name: "Idea",
  size: IconSize.Small,
  svg: IdeaSmall
} as const

export const IconIdeaMedium = {
  name: "Idea",
  size: IconSize.Medium,
  svg: IdeaMedium
} as const

export const IconIdentitycardFilledSmall = {
  name: "IdentitycardFilled",
  size: IconSize.Small,
  svg: IdentitycardFilledSmall
} as const

export const IconIdentitycardFilledMedium = {
  name: "IdentitycardFilled",
  size: IconSize.Medium,
  svg: IdentitycardFilledMedium
} as const

export const IconIdentitycardExtraLarge = {
  name: "Identitycard",
  size: IconSize.ExtraLarge,
  svg: IdentitycardExtraLarge
} as const

export const IconIdentitycardLarge = {
  name: "Identitycard",
  size: IconSize.Large,
  svg: IdentitycardLarge
} as const

export const IconIdentitycardSmall = {
  name: "Identitycard",
  size: IconSize.Small,
  svg: IdentitycardSmall
} as const

export const IconIdentitycardMedium = {
  name: "Identitycard",
  size: IconSize.Medium,
  svg: IdentitycardMedium
} as const

export const IconInventoryExtraLarge = {
  name: "Inventory",
  size: IconSize.ExtraLarge,
  svg: InventoryExtraLarge
} as const

export const IconInventoryLarge = {
  name: "Inventory",
  size: IconSize.Large,
  svg: InventoryLarge
} as const

export const IconInventorySmall = {
  name: "Inventory",
  size: IconSize.Small,
  svg: InventorySmall
} as const

export const IconInventoryMedium = {
  name: "Inventory",
  size: IconSize.Medium,
  svg: InventoryMedium
} as const

export const IconLetterFilledSmall = {
  name: "LetterFilled",
  size: IconSize.Small,
  svg: LetterFilledSmall
} as const

export const IconLetterFilledMedium = {
  name: "LetterFilled",
  size: IconSize.Medium,
  svg: LetterFilledMedium
} as const

export const IconLetterExtraLarge = {
  name: "Letter",
  size: IconSize.ExtraLarge,
  svg: LetterExtraLarge
} as const

export const IconLetterLarge = {
  name: "Letter",
  size: IconSize.Large,
  svg: LetterLarge
} as const

export const IconLetterSmall = {
  name: "Letter",
  size: IconSize.Small,
  svg: LetterSmall
} as const

export const IconLetterMedium = {
  name: "Letter",
  size: IconSize.Medium,
  svg: LetterMedium
} as const

export const IconLetterRevertFilledSmall = {
  name: "LetterRevertFilled",
  size: IconSize.Small,
  svg: LetterRevertFilledSmall
} as const

export const IconLetterRevertFilledMedium = {
  name: "LetterRevertFilled",
  size: IconSize.Medium,
  svg: LetterRevertFilledMedium
} as const

export const IconLetterRevertExtraLarge = {
  name: "LetterRevert",
  size: IconSize.ExtraLarge,
  svg: LetterRevertExtraLarge
} as const

export const IconLetterRevertLarge = {
  name: "LetterRevert",
  size: IconSize.Large,
  svg: LetterRevertLarge
} as const

export const IconLetterRevertSmall = {
  name: "LetterRevert",
  size: IconSize.Small,
  svg: LetterRevertSmall
} as const

export const IconLetterRevertMedium = {
  name: "LetterRevert",
  size: IconSize.Medium,
  svg: LetterRevertMedium
} as const

export const IconLibraryFilledSmall = {
  name: "LibraryFilled",
  size: IconSize.Small,
  svg: LibraryFilledSmall
} as const

export const IconLibraryFilledMedium = {
  name: "LibraryFilled",
  size: IconSize.Medium,
  svg: LibraryFilledMedium
} as const

export const IconLibraryExtraLarge = {
  name: "Library",
  size: IconSize.ExtraLarge,
  svg: LibraryExtraLarge
} as const

export const IconLibraryLarge = {
  name: "Library",
  size: IconSize.Large,
  svg: LibraryLarge
} as const

export const IconLibrarySmall = {
  name: "Library",
  size: IconSize.Small,
  svg: LibrarySmall
} as const

export const IconLibraryMedium = {
  name: "Library",
  size: IconSize.Medium,
  svg: LibraryMedium
} as const

export const IconLockFilledSmall = {
  name: "LockFilled",
  size: IconSize.Small,
  svg: LockFilledSmall
} as const

export const IconLockFilledMedium = {
  name: "LockFilled",
  size: IconSize.Medium,
  svg: LockFilledMedium
} as const

export const IconLockExtraLarge = {
  name: "Lock",
  size: IconSize.ExtraLarge,
  svg: LockExtraLarge
} as const

export const IconLockLarge = {
  name: "Lock",
  size: IconSize.Large,
  svg: LockLarge
} as const

export const IconLockSmall = {
  name: "Lock",
  size: IconSize.Small,
  svg: LockSmall
} as const

export const IconLockMedium = {
  name: "Lock",
  size: IconSize.Medium,
  svg: LockMedium
} as const

export const IconMappinFilledSmall = {
  name: "MappinFilled",
  size: IconSize.Small,
  svg: MappinFilledSmall
} as const

export const IconMappinFilledMedium = {
  name: "MappinFilled",
  size: IconSize.Medium,
  svg: MappinFilledMedium
} as const

export const IconMappinExtraLarge = {
  name: "Mappin",
  size: IconSize.ExtraLarge,
  svg: MappinExtraLarge
} as const

export const IconMappinLarge = {
  name: "Mappin",
  size: IconSize.Large,
  svg: MappinLarge
} as const

export const IconMappinSmall = {
  name: "Mappin",
  size: IconSize.Small,
  svg: MappinSmall
} as const

export const IconMappinMedium = {
  name: "Mappin",
  size: IconSize.Medium,
  svg: MappinMedium
} as const

export const IconMoneyWarningExtraLarge = {
  name: "MoneyWarning",
  size: IconSize.ExtraLarge,
  svg: MoneyWarningExtraLarge
} as const

export const IconMoneyWarningLarge = {
  name: "MoneyWarning",
  size: IconSize.Large,
  svg: MoneyWarningLarge
} as const

export const IconMoneyWarningSmall = {
  name: "MoneyWarning",
  size: IconSize.Small,
  svg: MoneyWarningSmall
} as const

export const IconMoneyWarningMedium = {
  name: "MoneyWarning",
  size: IconSize.Medium,
  svg: MoneyWarningMedium
} as const

export const IconMoneybagFilledSmall = {
  name: "MoneybagFilled",
  size: IconSize.Small,
  svg: MoneybagFilledSmall
} as const

export const IconMoneybagFilledMedium = {
  name: "MoneybagFilled",
  size: IconSize.Medium,
  svg: MoneybagFilledMedium
} as const

export const IconMoneybagExtraLarge = {
  name: "Moneybag",
  size: IconSize.ExtraLarge,
  svg: MoneybagExtraLarge
} as const

export const IconMoneybagLarge = {
  name: "Moneybag",
  size: IconSize.Large,
  svg: MoneybagLarge
} as const

export const IconMoneybagSmall = {
  name: "Moneybag",
  size: IconSize.Small,
  svg: MoneybagSmall
} as const

export const IconMoneybagMedium = {
  name: "Moneybag",
  size: IconSize.Medium,
  svg: MoneybagMedium
} as const

export const IconMountingMedium = {
  name: "Mounting",
  size: IconSize.Medium,
  svg: MountingMedium
} as const

export const IconMultipaymentsExtraLarge = {
  name: "Multipayments",
  size: IconSize.ExtraLarge,
  svg: MultipaymentsExtraLarge
} as const

export const IconMultipaymentsLarge = {
  name: "Multipayments",
  size: IconSize.Large,
  svg: MultipaymentsLarge
} as const

export const IconMultipaymentsSmall = {
  name: "Multipayments",
  size: IconSize.Small,
  svg: MultipaymentsSmall
} as const

export const IconMultipaymentsMedium = {
  name: "Multipayments",
  size: IconSize.Medium,
  svg: MultipaymentsMedium
} as const

export const IconNavigationMedium = {
  name: "Navigation",
  size: IconSize.Medium,
  svg: NavigationMedium
} as const

export const IconNotificationFilledSmall = {
  name: "NotificationFilled",
  size: IconSize.Small,
  svg: NotificationFilledSmall
} as const

export const IconNotificationFilledMedium = {
  name: "NotificationFilled",
  size: IconSize.Medium,
  svg: NotificationFilledMedium
} as const

export const IconNotificationExtraLarge = {
  name: "Notification",
  size: IconSize.ExtraLarge,
  svg: NotificationExtraLarge
} as const

export const IconNotificationLarge = {
  name: "Notification",
  size: IconSize.Large,
  svg: NotificationLarge
} as const

export const IconNotificationSmall = {
  name: "Notification",
  size: IconSize.Small,
  svg: NotificationSmall
} as const

export const IconNotificationMedium = {
  name: "Notification",
  size: IconSize.Medium,
  svg: NotificationMedium
} as const

export const IconOnlinePayExtraLarge = {
  name: "OnlinePay",
  size: IconSize.ExtraLarge,
  svg: OnlinePayExtraLarge
} as const

export const IconOnlinePayLarge = {
  name: "OnlinePay",
  size: IconSize.Large,
  svg: OnlinePayLarge
} as const

export const IconOnlinePaySmall = {
  name: "OnlinePay",
  size: IconSize.Small,
  svg: OnlinePaySmall
} as const

export const IconOnlinePayMedium = {
  name: "OnlinePay",
  size: IconSize.Medium,
  svg: OnlinePayMedium
} as const

export const IconOpenInNewExtraLarge = {
  name: "OpenInNew",
  size: IconSize.ExtraLarge,
  svg: OpenInNewExtraLarge
} as const

export const IconOpenInNewLarge = {
  name: "OpenInNew",
  size: IconSize.Large,
  svg: OpenInNewLarge
} as const

export const IconOpenInNewExtraSmall = {
  name: "OpenInNew",
  size: IconSize.ExtraSmall,
  svg: OpenInNewExtraSmall
} as const

export const IconOpenInNewSmall = {
  name: "OpenInNew",
  size: IconSize.Small,
  svg: OpenInNewSmall
} as const

export const IconOpenInNewMedium = {
  name: "OpenInNew",
  size: IconSize.Medium,
  svg: OpenInNewMedium
} as const

export const IconOrdersExtraLarge = {
  name: "Orders",
  size: IconSize.ExtraLarge,
  svg: OrdersExtraLarge
} as const

export const IconOrdersLarge = {
  name: "Orders",
  size: IconSize.Large,
  svg: OrdersLarge
} as const

export const IconOrdersSmall = {
  name: "Orders",
  size: IconSize.Small,
  svg: OrdersSmall
} as const

export const IconOrdersMedium = {
  name: "Orders",
  size: IconSize.Medium,
  svg: OrdersMedium
} as const

export const IconPaymentOptionsExtraLarge = {
  name: "PaymentOptions",
  size: IconSize.ExtraLarge,
  svg: PaymentOptionsExtraLarge
} as const

export const IconPaymentOptionsLarge = {
  name: "PaymentOptions",
  size: IconSize.Large,
  svg: PaymentOptionsLarge
} as const

export const IconPaymentOptionsSmall = {
  name: "PaymentOptions",
  size: IconSize.Small,
  svg: PaymentOptionsSmall
} as const

export const IconPaymentOptionsMedium = {
  name: "PaymentOptions",
  size: IconSize.Medium,
  svg: PaymentOptionsMedium
} as const

export const IconPdfFilledSmall = {
  name: "PdfFilled",
  size: IconSize.Small,
  svg: PdfFilledSmall
} as const

export const IconPdfFilledMedium = {
  name: "PdfFilled",
  size: IconSize.Medium,
  svg: PdfFilledMedium
} as const

export const IconPdfExtraLarge = {
  name: "Pdf",
  size: IconSize.ExtraLarge,
  svg: PdfExtraLarge
} as const

export const IconPdfLarge = {
  name: "Pdf",
  size: IconSize.Large,
  svg: PdfLarge
} as const

export const IconPdfSmall = {
  name: "Pdf",
  size: IconSize.Small,
  svg: PdfSmall
} as const

export const IconPdfMedium = {
  name: "Pdf",
  size: IconSize.Medium,
  svg: PdfMedium
} as const

export const IconPersonTwoExtraLarge = {
  name: "PersonTwo",
  size: IconSize.ExtraLarge,
  svg: PersonTwoExtraLarge
} as const

export const IconPersonTwoLarge = {
  name: "PersonTwo",
  size: IconSize.Large,
  svg: PersonTwoLarge
} as const

export const IconPersonTwoSmall = {
  name: "PersonTwo",
  size: IconSize.Small,
  svg: PersonTwoSmall
} as const

export const IconPersonTwoMedium = {
  name: "PersonTwo",
  size: IconSize.Medium,
  svg: PersonTwoMedium
} as const

export const IconPersonThreeExtraLarge = {
  name: "PersonThree",
  size: IconSize.ExtraLarge,
  svg: PersonThreeExtraLarge
} as const

export const IconPersonThreeLarge = {
  name: "PersonThree",
  size: IconSize.Large,
  svg: PersonThreeLarge
} as const

export const IconPersonThreeSmall = {
  name: "PersonThree",
  size: IconSize.Small,
  svg: PersonThreeSmall
} as const

export const IconPersonThreeMedium = {
  name: "PersonThree",
  size: IconSize.Medium,
  svg: PersonThreeMedium
} as const

export const IconPersonFourExtraLarge = {
  name: "PersonFour",
  size: IconSize.ExtraLarge,
  svg: PersonFourExtraLarge
} as const

export const IconPersonFourLarge = {
  name: "PersonFour",
  size: IconSize.Large,
  svg: PersonFourLarge
} as const

export const IconPersonFourSmall = {
  name: "PersonFour",
  size: IconSize.Small,
  svg: PersonFourSmall
} as const

export const IconPersonFourMedium = {
  name: "PersonFour",
  size: IconSize.Medium,
  svg: PersonFourMedium
} as const

export const IconPersonFiveExtraLarge = {
  name: "PersonFive",
  size: IconSize.ExtraLarge,
  svg: PersonFiveExtraLarge
} as const

export const IconPersonFiveLarge = {
  name: "PersonFive",
  size: IconSize.Large,
  svg: PersonFiveLarge
} as const

export const IconPersonFiveSmall = {
  name: "PersonFive",
  size: IconSize.Small,
  svg: PersonFiveSmall
} as const

export const IconPersonFiveMedium = {
  name: "PersonFive",
  size: IconSize.Medium,
  svg: PersonFiveMedium
} as const

export const IconPersonFilledSmall = {
  name: "PersonFilled",
  size: IconSize.Small,
  svg: PersonFilledSmall
} as const

export const IconPersonFilledMedium = {
  name: "PersonFilled",
  size: IconSize.Medium,
  svg: PersonFilledMedium
} as const

export const IconPersonExtraLarge = {
  name: "Person",
  size: IconSize.ExtraLarge,
  svg: PersonExtraLarge
} as const

export const IconPersonLarge = {
  name: "Person",
  size: IconSize.Large,
  svg: PersonLarge
} as const

export const IconPersonSmall = {
  name: "Person",
  size: IconSize.Small,
  svg: PersonSmall
} as const

export const IconPersonMedium = {
  name: "Person",
  size: IconSize.Medium,
  svg: PersonMedium
} as const

export const IconPiechartFilledSmall = {
  name: "PiechartFilled",
  size: IconSize.Small,
  svg: PiechartFilledSmall
} as const

export const IconPiechartFilledMedium = {
  name: "PiechartFilled",
  size: IconSize.Medium,
  svg: PiechartFilledMedium
} as const

export const IconPiechartExtraLarge = {
  name: "Piechart",
  size: IconSize.ExtraLarge,
  svg: PiechartExtraLarge
} as const

export const IconPiechartLarge = {
  name: "Piechart",
  size: IconSize.Large,
  svg: PiechartLarge
} as const

export const IconPiechartSmall = {
  name: "Piechart",
  size: IconSize.Small,
  svg: PiechartSmall
} as const

export const IconPiechartMedium = {
  name: "Piechart",
  size: IconSize.Medium,
  svg: PiechartMedium
} as const

export const IconPrinterPaperRollMedium = {
  name: "PrinterPaperRoll",
  size: IconSize.Medium,
  svg: PrinterPaperRollMedium
} as const

export const IconProductsFilledSmall = {
  name: "ProductsFilled",
  size: IconSize.Small,
  svg: ProductsFilledSmall
} as const

export const IconProductsFilledMedium = {
  name: "ProductsFilled",
  size: IconSize.Medium,
  svg: ProductsFilledMedium
} as const

export const IconProductsExtraLarge = {
  name: "Products",
  size: IconSize.ExtraLarge,
  svg: ProductsExtraLarge
} as const

export const IconProductsLarge = {
  name: "Products",
  size: IconSize.Large,
  svg: ProductsLarge
} as const

export const IconProductsSmall = {
  name: "Products",
  size: IconSize.Small,
  svg: ProductsSmall
} as const

export const IconProductsMedium = {
  name: "Products",
  size: IconSize.Medium,
  svg: ProductsMedium
} as const

export const IconPuzzleFilledSmall = {
  name: "PuzzleFilled",
  size: IconSize.Small,
  svg: PuzzleFilledSmall
} as const

export const IconPuzzleFilledMedium = {
  name: "PuzzleFilled",
  size: IconSize.Medium,
  svg: PuzzleFilledMedium
} as const

export const IconPuzzleExtraLarge = {
  name: "Puzzle",
  size: IconSize.ExtraLarge,
  svg: PuzzleExtraLarge
} as const

export const IconPuzzleLarge = {
  name: "Puzzle",
  size: IconSize.Large,
  svg: PuzzleLarge
} as const

export const IconPuzzleSmall = {
  name: "Puzzle",
  size: IconSize.Small,
  svg: PuzzleSmall
} as const

export const IconPuzzleMedium = {
  name: "Puzzle",
  size: IconSize.Medium,
  svg: PuzzleMedium
} as const

export const IconQrCodeExtraLarge = {
  name: "QrCode",
  size: IconSize.ExtraLarge,
  svg: QrCodeExtraLarge
} as const

export const IconQrCodeLarge = {
  name: "QrCode",
  size: IconSize.Large,
  svg: QrCodeLarge
} as const

export const IconQrCodeSmall = {
  name: "QrCode",
  size: IconSize.Small,
  svg: QrCodeSmall
} as const

export const IconQrCodeMedium = {
  name: "QrCode",
  size: IconSize.Medium,
  svg: QrCodeMedium
} as const

export const IconReceiptFilledSmall = {
  name: "ReceiptFilled",
  size: IconSize.Small,
  svg: ReceiptFilledSmall
} as const

export const IconReceiptFilledMedium = {
  name: "ReceiptFilled",
  size: IconSize.Medium,
  svg: ReceiptFilledMedium
} as const

export const IconReceiptExtraLarge = {
  name: "Receipt",
  size: IconSize.ExtraLarge,
  svg: ReceiptExtraLarge
} as const

export const IconReceiptLarge = {
  name: "Receipt",
  size: IconSize.Large,
  svg: ReceiptLarge
} as const

export const IconReceiptSmall = {
  name: "Receipt",
  size: IconSize.Small,
  svg: ReceiptSmall
} as const

export const IconReceiptMedium = {
  name: "Receipt",
  size: IconSize.Medium,
  svg: ReceiptMedium
} as const

export const IconRefundExtraLarge = {
  name: "Refund",
  size: IconSize.ExtraLarge,
  svg: RefundExtraLarge
} as const

export const IconRefundLarge = {
  name: "Refund",
  size: IconSize.Large,
  svg: RefundLarge
} as const

export const IconRefundSmall = {
  name: "Refund",
  size: IconSize.Small,
  svg: RefundSmall
} as const

export const IconRefundMedium = {
  name: "Refund",
  size: IconSize.Medium,
  svg: RefundMedium
} as const

export const IconReorderSmall = {
  name: "Reorder",
  size: IconSize.Small,
  svg: ReorderSmall
} as const

export const IconReorderMedium = {
  name: "Reorder",
  size: IconSize.Medium,
  svg: ReorderMedium
} as const

export const IconReportsFilledSmall = {
  name: "ReportsFilled",
  size: IconSize.Small,
  svg: ReportsFilledSmall
} as const

export const IconReportsFilledMedium = {
  name: "ReportsFilled",
  size: IconSize.Medium,
  svg: ReportsFilledMedium
} as const

export const IconReportsExtraLarge = {
  name: "Reports",
  size: IconSize.ExtraLarge,
  svg: ReportsExtraLarge
} as const

export const IconReportsLarge = {
  name: "Reports",
  size: IconSize.Large,
  svg: ReportsLarge
} as const

export const IconReportsSmall = {
  name: "Reports",
  size: IconSize.Small,
  svg: ReportsSmall
} as const

export const IconReportsMedium = {
  name: "Reports",
  size: IconSize.Medium,
  svg: ReportsMedium
} as const

export const IconSearchFilledSmall = {
  name: "SearchFilled",
  size: IconSize.Small,
  svg: SearchFilledSmall
} as const

export const IconSearchFilledMedium = {
  name: "SearchFilled",
  size: IconSize.Medium,
  svg: SearchFilledMedium
} as const

export const IconSearchExtraLarge = {
  name: "Search",
  size: IconSize.ExtraLarge,
  svg: SearchExtraLarge
} as const

export const IconSearchLarge = {
  name: "Search",
  size: IconSize.Large,
  svg: SearchLarge
} as const

export const IconSearchSmall = {
  name: "Search",
  size: IconSize.Small,
  svg: SearchSmall
} as const

export const IconSearchMedium = {
  name: "Search",
  size: IconSize.Medium,
  svg: SearchMedium
} as const

export const IconSendFilledSmall = {
  name: "SendFilled",
  size: IconSize.Small,
  svg: SendFilledSmall
} as const

export const IconSendFilledMedium = {
  name: "SendFilled",
  size: IconSize.Medium,
  svg: SendFilledMedium
} as const

export const IconSendExtraLarge = {
  name: "Send",
  size: IconSize.ExtraLarge,
  svg: SendExtraLarge
} as const

export const IconSendLarge = {
  name: "Send",
  size: IconSize.Large,
  svg: SendLarge
} as const

export const IconSendSmall = {
  name: "Send",
  size: IconSize.Small,
  svg: SendSmall
} as const

export const IconSendMedium = {
  name: "Send",
  size: IconSize.Medium,
  svg: SendMedium
} as const

export const IconSettingsFilledSmall = {
  name: "SettingsFilled",
  size: IconSize.Small,
  svg: SettingsFilledSmall
} as const

export const IconSettingsFilledMedium = {
  name: "SettingsFilled",
  size: IconSize.Medium,
  svg: SettingsFilledMedium
} as const

export const IconSettingsExtraLarge = {
  name: "Settings",
  size: IconSize.ExtraLarge,
  svg: SettingsExtraLarge
} as const

export const IconSettingsLarge = {
  name: "Settings",
  size: IconSize.Large,
  svg: SettingsLarge
} as const

export const IconSettingsExtraSmall = {
  name: "Settings",
  size: IconSize.ExtraSmall,
  svg: SettingsExtraSmall
} as const

export const IconSettingsSmall = {
  name: "Settings",
  size: IconSize.Small,
  svg: SettingsSmall
} as const

export const IconSettingsMedium = {
  name: "Settings",
  size: IconSize.Medium,
  svg: SettingsMedium
} as const

export const IconShareFilledSmall = {
  name: "ShareFilled",
  size: IconSize.Small,
  svg: ShareFilledSmall
} as const

export const IconShareFilledMedium = {
  name: "ShareFilled",
  size: IconSize.Medium,
  svg: ShareFilledMedium
} as const

export const IconShareExtraLarge = {
  name: "Share",
  size: IconSize.ExtraLarge,
  svg: ShareExtraLarge
} as const

export const IconShareLarge = {
  name: "Share",
  size: IconSize.Large,
  svg: ShareLarge
} as const

export const IconShareSmall = {
  name: "Share",
  size: IconSize.Small,
  svg: ShareSmall
} as const

export const IconShareMedium = {
  name: "Share",
  size: IconSize.Medium,
  svg: ShareMedium
} as const

export const IconShoppingBasketFilledSmall = {
  name: "ShoppingBasketFilled",
  size: IconSize.Small,
  svg: ShoppingBasketFilledSmall
} as const

export const IconShoppingBasketFilledMedium = {
  name: "ShoppingBasketFilled",
  size: IconSize.Medium,
  svg: ShoppingBasketFilledMedium
} as const

export const IconShoppingBasketExtraLarge = {
  name: "ShoppingBasket",
  size: IconSize.ExtraLarge,
  svg: ShoppingBasketExtraLarge
} as const

export const IconShoppingBasketLarge = {
  name: "ShoppingBasket",
  size: IconSize.Large,
  svg: ShoppingBasketLarge
} as const

export const IconShoppingBasketSmall = {
  name: "ShoppingBasket",
  size: IconSize.Small,
  svg: ShoppingBasketSmall
} as const

export const IconShoppingBasketMedium = {
  name: "ShoppingBasket",
  size: IconSize.Medium,
  svg: ShoppingBasketMedium
} as const

export const IconShoppingbagFilledSmall = {
  name: "ShoppingbagFilled",
  size: IconSize.Small,
  svg: ShoppingbagFilledSmall
} as const

export const IconShoppingbagFilledMedium = {
  name: "ShoppingbagFilled",
  size: IconSize.Medium,
  svg: ShoppingbagFilledMedium
} as const

export const IconShoppingbagExtraLarge = {
  name: "Shoppingbag",
  size: IconSize.ExtraLarge,
  svg: ShoppingbagExtraLarge
} as const

export const IconShoppingbagLarge = {
  name: "Shoppingbag",
  size: IconSize.Large,
  svg: ShoppingbagLarge
} as const

export const IconShoppingbagSmall = {
  name: "Shoppingbag",
  size: IconSize.Small,
  svg: ShoppingbagSmall
} as const

export const IconShoppingbagMedium = {
  name: "Shoppingbag",
  size: IconSize.Medium,
  svg: ShoppingbagMedium
} as const

export const IconShoppingcartFilledSmall = {
  name: "ShoppingcartFilled",
  size: IconSize.Small,
  svg: ShoppingcartFilledSmall
} as const

export const IconShoppingcartFilledMedium = {
  name: "ShoppingcartFilled",
  size: IconSize.Medium,
  svg: ShoppingcartFilledMedium
} as const

export const IconShoppingcartExtraLarge = {
  name: "Shoppingcart",
  size: IconSize.ExtraLarge,
  svg: ShoppingcartExtraLarge
} as const

export const IconShoppingcartLarge = {
  name: "Shoppingcart",
  size: IconSize.Large,
  svg: ShoppingcartLarge
} as const

export const IconShoppingcartSmall = {
  name: "Shoppingcart",
  size: IconSize.Small,
  svg: ShoppingcartSmall
} as const

export const IconShoppingcartMedium = {
  name: "Shoppingcart",
  size: IconSize.Medium,
  svg: ShoppingcartMedium
} as const

export const IconShowExtraLarge = {
  name: "Show",
  size: IconSize.ExtraLarge,
  svg: ShowExtraLarge
} as const

export const IconShowLarge = {
  name: "Show",
  size: IconSize.Large,
  svg: ShowLarge
} as const

export const IconShowSmall = {
  name: "Show",
  size: IconSize.Small,
  svg: ShowSmall
} as const

export const IconShowMedium = {
  name: "Show",
  size: IconSize.Medium,
  svg: ShowMedium
} as const

export const IconShutdownFilledSmall = {
  name: "ShutdownFilled",
  size: IconSize.Small,
  svg: ShutdownFilledSmall
} as const

export const IconShutdownFilledMedium = {
  name: "ShutdownFilled",
  size: IconSize.Medium,
  svg: ShutdownFilledMedium
} as const

export const IconShutdownExtraLarge = {
  name: "Shutdown",
  size: IconSize.ExtraLarge,
  svg: ShutdownExtraLarge
} as const

export const IconShutdownLarge = {
  name: "Shutdown",
  size: IconSize.Large,
  svg: ShutdownLarge
} as const

export const IconShutdownSmall = {
  name: "Shutdown",
  size: IconSize.Small,
  svg: ShutdownSmall
} as const

export const IconShutdownMedium = {
  name: "Shutdown",
  size: IconSize.Medium,
  svg: ShutdownMedium
} as const

export const IconStaffFilledSmall = {
  name: "StaffFilled",
  size: IconSize.Small,
  svg: StaffFilledSmall
} as const

export const IconStaffFilledMedium = {
  name: "StaffFilled",
  size: IconSize.Medium,
  svg: StaffFilledMedium
} as const

export const IconStaffExtraLarge = {
  name: "Staff",
  size: IconSize.ExtraLarge,
  svg: StaffExtraLarge
} as const

export const IconStaffLarge = {
  name: "Staff",
  size: IconSize.Large,
  svg: StaffLarge
} as const

export const IconStaffSmall = {
  name: "Staff",
  size: IconSize.Small,
  svg: StaffSmall
} as const

export const IconStaffMedium = {
  name: "Staff",
  size: IconSize.Medium,
  svg: StaffMedium
} as const

export const IconStarFilledSmall = {
  name: "StarFilled",
  size: IconSize.Small,
  svg: StarFilledSmall
} as const

export const IconStarFilledMedium = {
  name: "StarFilled",
  size: IconSize.Medium,
  svg: StarFilledMedium
} as const

export const IconStarExtraLarge = {
  name: "Star",
  size: IconSize.ExtraLarge,
  svg: StarExtraLarge
} as const

export const IconStarLarge = {
  name: "Star",
  size: IconSize.Large,
  svg: StarLarge
} as const

export const IconStarExtraSmall = {
  name: "Star",
  size: IconSize.ExtraSmall,
  svg: StarExtraSmall
} as const

export const IconStarSmall = {
  name: "Star",
  size: IconSize.Small,
  svg: StarSmall
} as const

export const IconStarMedium = {
  name: "Star",
  size: IconSize.Medium,
  svg: StarMedium
} as const

export const IconTagFilledSmall = {
  name: "TagFilled",
  size: IconSize.Small,
  svg: TagFilledSmall
} as const

export const IconTagFilledMedium = {
  name: "TagFilled",
  size: IconSize.Medium,
  svg: TagFilledMedium
} as const

export const IconTagExtraLarge = {
  name: "Tag",
  size: IconSize.ExtraLarge,
  svg: TagExtraLarge
} as const

export const IconTagLarge = {
  name: "Tag",
  size: IconSize.Large,
  svg: TagLarge
} as const

export const IconTagSmall = {
  name: "Tag",
  size: IconSize.Small,
  svg: TagSmall
} as const

export const IconTagMedium = {
  name: "Tag",
  size: IconSize.Medium,
  svg: TagMedium
} as const

export const IconTapPhoneExtraLarge = {
  name: "TapPhone",
  size: IconSize.ExtraLarge,
  svg: TapPhoneExtraLarge
} as const

export const IconTapPhoneLarge = {
  name: "TapPhone",
  size: IconSize.Large,
  svg: TapPhoneLarge
} as const

export const IconTapPhoneSmall = {
  name: "TapPhone",
  size: IconSize.Small,
  svg: TapPhoneSmall
} as const

export const IconTapPhoneMedium = {
  name: "TapPhone",
  size: IconSize.Medium,
  svg: TapPhoneMedium
} as const

export const IconTaxesExtraLarge = {
  name: "Taxes",
  size: IconSize.ExtraLarge,
  svg: TaxesExtraLarge
} as const

export const IconTaxesLarge = {
  name: "Taxes",
  size: IconSize.Large,
  svg: TaxesLarge
} as const

export const IconTaxesExtraSmall = {
  name: "Taxes",
  size: IconSize.ExtraSmall,
  svg: TaxesExtraSmall
} as const

export const IconTaxesSmall = {
  name: "Taxes",
  size: IconSize.Small,
  svg: TaxesSmall
} as const

export const IconTaxesMedium = {
  name: "Taxes",
  size: IconSize.Medium,
  svg: TaxesMedium
} as const

export const IconTipsExtraLarge = {
  name: "Tips",
  size: IconSize.ExtraLarge,
  svg: TipsExtraLarge
} as const

export const IconTipsLarge = {
  name: "Tips",
  size: IconSize.Large,
  svg: TipsLarge
} as const

export const IconTipsSmall = {
  name: "Tips",
  size: IconSize.Small,
  svg: TipsSmall
} as const

export const IconTipsMedium = {
  name: "Tips",
  size: IconSize.Medium,
  svg: TipsMedium
} as const

export const IconTrashFilledSmall = {
  name: "TrashFilled",
  size: IconSize.Small,
  svg: TrashFilledSmall
} as const

export const IconTrashFilledMedium = {
  name: "TrashFilled",
  size: IconSize.Medium,
  svg: TrashFilledMedium
} as const

export const IconTrashExtraLarge = {
  name: "Trash",
  size: IconSize.ExtraLarge,
  svg: TrashExtraLarge
} as const

export const IconTrashLarge = {
  name: "Trash",
  size: IconSize.Large,
  svg: TrashLarge
} as const

export const IconTrashExtraSmall = {
  name: "Trash",
  size: IconSize.ExtraSmall,
  svg: TrashExtraSmall
} as const

export const IconTrashSmall = {
  name: "Trash",
  size: IconSize.Small,
  svg: TrashSmall
} as const

export const IconTrashMedium = {
  name: "Trash",
  size: IconSize.Medium,
  svg: TrashMedium
} as const

export const IconUnknownPaymentExtraLarge = {
  name: "UnknownPayment",
  size: IconSize.ExtraLarge,
  svg: UnknownPaymentExtraLarge
} as const

export const IconUnknownPaymentLarge = {
  name: "UnknownPayment",
  size: IconSize.Large,
  svg: UnknownPaymentLarge
} as const

export const IconUnknownPaymentSmall = {
  name: "UnknownPayment",
  size: IconSize.Small,
  svg: UnknownPaymentSmall
} as const

export const IconUnknownPaymentMedium = {
  name: "UnknownPayment",
  size: IconSize.Medium,
  svg: UnknownPaymentMedium
} as const

export const IconUnlockedFilledSmall = {
  name: "UnlockedFilled",
  size: IconSize.Small,
  svg: UnlockedFilledSmall
} as const

export const IconUnlockedFilledMedium = {
  name: "UnlockedFilled",
  size: IconSize.Medium,
  svg: UnlockedFilledMedium
} as const

export const IconUnlockedExtraLarge = {
  name: "Unlocked",
  size: IconSize.ExtraLarge,
  svg: UnlockedExtraLarge
} as const

export const IconUnlockedLarge = {
  name: "Unlocked",
  size: IconSize.Large,
  svg: UnlockedLarge
} as const

export const IconUnlockedSmall = {
  name: "Unlocked",
  size: IconSize.Small,
  svg: UnlockedSmall
} as const

export const IconUnlockedMedium = {
  name: "Unlocked",
  size: IconSize.Medium,
  svg: UnlockedMedium
} as const

export const IconUserGenericExtraLarge = {
  name: "UserGeneric",
  size: IconSize.ExtraLarge,
  svg: UserGenericExtraLarge
} as const

export const IconUserGenericLarge = {
  name: "UserGeneric",
  size: IconSize.Large,
  svg: UserGenericLarge
} as const

export const IconUserGenericExtraSmall = {
  name: "UserGeneric",
  size: IconSize.ExtraSmall,
  svg: UserGenericExtraSmall
} as const

export const IconUserGenericSmall = {
  name: "UserGeneric",
  size: IconSize.Small,
  svg: UserGenericSmall
} as const

export const IconUserGenericMedium = {
  name: "UserGeneric",
  size: IconSize.Medium,
  svg: UserGenericMedium
} as const

export const IconVolumeFilledSmall = {
  name: "VolumeFilled",
  size: IconSize.Small,
  svg: VolumeFilledSmall
} as const

export const IconVolumeFilledMedium = {
  name: "VolumeFilled",
  size: IconSize.Medium,
  svg: VolumeFilledMedium
} as const

export const IconVolumeExtraLarge = {
  name: "Volume",
  size: IconSize.ExtraLarge,
  svg: VolumeExtraLarge
} as const

export const IconVolumeLarge = {
  name: "Volume",
  size: IconSize.Large,
  svg: VolumeLarge
} as const

export const IconVolumeSmall = {
  name: "Volume",
  size: IconSize.Small,
  svg: VolumeSmall
} as const

export const IconVolumeMedium = {
  name: "Volume",
  size: IconSize.Medium,
  svg: VolumeMedium
} as const

export const IconZoominFilledSmall = {
  name: "ZoominFilled",
  size: IconSize.Small,
  svg: ZoominFilledSmall
} as const

export const IconZoominFilledMedium = {
  name: "ZoominFilled",
  size: IconSize.Medium,
  svg: ZoominFilledMedium
} as const

export const IconZoominExtraLarge = {
  name: "Zoomin",
  size: IconSize.ExtraLarge,
  svg: ZoominExtraLarge
} as const

export const IconZoominLarge = {
  name: "Zoomin",
  size: IconSize.Large,
  svg: ZoominLarge
} as const

export const IconZoominSmall = {
  name: "Zoomin",
  size: IconSize.Small,
  svg: ZoominSmall
} as const

export const IconZoominMedium = {
  name: "Zoomin",
  size: IconSize.Medium,
  svg: ZoominMedium
} as const

export const IconZoomoutFilledSmall = {
  name: "ZoomoutFilled",
  size: IconSize.Small,
  svg: ZoomoutFilledSmall
} as const

export const IconZoomoutFilledMedium = {
  name: "ZoomoutFilled",
  size: IconSize.Medium,
  svg: ZoomoutFilledMedium
} as const

export const IconZoomoutExtraLarge = {
  name: "Zoomout",
  size: IconSize.ExtraLarge,
  svg: ZoomoutExtraLarge
} as const

export const IconZoomoutLarge = {
  name: "Zoomout",
  size: IconSize.Large,
  svg: ZoomoutLarge
} as const

export const IconZoomoutSmall = {
  name: "Zoomout",
  size: IconSize.Small,
  svg: ZoomoutSmall
} as const

export const IconZoomoutMedium = {
  name: "Zoomout",
  size: IconSize.Medium,
  svg: ZoomoutMedium
} as const

export const IconsExtraLarge = [IconCircleCrossExtraLarge, IconCircleMinusExtraLarge, IconCirclePlusExtraLarge, IconCircleTickOpenExtraLarge, IconCircleTickExtraLarge, IconClockExtraLarge, IconCompassExtraLarge, IconDeadExtraLarge, IconDeniedExtraLarge, IconHappyExtraLarge, IconHelpExtraLarge, IconHumbleFailExtraLarge, IconInfoExtraLarge, IconSadExtraLarge, IconVeryHappyExtraLarge, IconWarningExtraLarge, IconBatteryChargingExtraLarge, IconBatteryCriticalExtraLarge, IconBatteryEmptyExtraLarge, IconBatteryOneBarExtraLarge, IconBatteryThreeBarsExtraLarge, IconBatteryTwoBarsExtraLarge, IconCameraExtraLarge, IconCardReaderOneDisconnectedExtraLarge, IconCardReaderOneExtraLarge, IconCashDrawerExtraLarge, IconHeadphonesExtraLarge, IconLaptopExtraLarge, IconMicrophoneExtraLarge, IconMiuraDisconnectedExtraLarge, IconMiuraExtraLarge, IconPeripheralsExtraLarge, IconPhoneExtraLarge, IconReceiptPrinterExtraLarge, IconStandardPrinterExtraLarge, IconTabletExtraLarge, IconUsbCableExtraLarge, IconWifiDisabledExtraLarge, IconWifiExtraLarge, IconArrowDownExtraLarge, IconArrowLeftExtraLarge, IconArrowRightExtraLarge, IconArrowUpExtraLarge, IconBarDiagramExtraLarge, IconCrossExtraLarge, IconDownloadExtraLarge, IconExportExtraLarge, IconImportExtraLarge, IconMenuExtraLarge, IconMinusExtraLarge, IconMoreExtraLarge, IconPercentExtraLarge, IconPlusExtraLarge, IconReloadExtraLarge, IconRevertExtraLarge, IconSimpleArrowDownExtraLarge, IconSimpleArrowLeftExtraLarge, IconSimpleArrowRightExtraLarge, IconSimpleArrowUpExtraLarge, IconSortDownExtraLarge, IconSortUpExtraLarge, IconTickExtraLarge, IconUndoExtraLarge, IconOneTwoThreeExtraLarge, IconBackspaceExtraLarge, IconBankExtraLarge, IconBarcodeExtraLarge, IconBarcodeokExtraLarge, IconBulletlistExtraLarge, IconCardOverPhoneExtraLarge, IconCardExtraLarge, IconCashExtraLarge, IconChatExtraLarge, IconChipExtraLarge, IconCloudExtraLarge, IconCogExtraLarge, IconCopyClipboardExtraLarge, IconDateExtraLarge, IconDeliveryExtraLarge, IconDepositExtraLarge, IconEcommerceExtraLarge, IconEditExtraLarge, IconEmailExtraLarge, IconErrorExtraLarge, IconFilterExtraLarge, IconFundingExtraLarge, IconGiftCardExtraLarge, IconHeartExtraLarge, IconHideExtraLarge, IconHidekeyboardExtraLarge, IconHomeExtraLarge, IconIdCardExtraLarge, IconIdeaExtraLarge, IconIdentitycardExtraLarge, IconInventoryExtraLarge, IconLetterRevertExtraLarge, IconLetterExtraLarge, IconLibraryExtraLarge, IconLockExtraLarge, IconMappinExtraLarge, IconMoneyWarningExtraLarge, IconMoneybagExtraLarge, IconMultipaymentsExtraLarge, IconNotificationExtraLarge, IconOnlinePayExtraLarge, IconOpenInNewExtraLarge, IconOrdersExtraLarge, IconPaymentOptionsExtraLarge, IconPdfExtraLarge, IconPersonTwoExtraLarge, IconPersonThreeExtraLarge, IconPersonFourExtraLarge, IconPersonFiveExtraLarge, IconPersonExtraLarge, IconPiechartExtraLarge, IconProductsExtraLarge, IconPuzzleExtraLarge, IconQrCodeExtraLarge, IconReceiptExtraLarge, IconRefundExtraLarge, IconReportsExtraLarge, IconSearchExtraLarge, IconSendExtraLarge, IconSettingsExtraLarge, IconShareExtraLarge, IconShoppingBasketExtraLarge, IconShoppingbagExtraLarge, IconShoppingcartExtraLarge, IconShowExtraLarge, IconShutdownExtraLarge, IconStaffExtraLarge, IconStarExtraLarge, IconTagExtraLarge, IconTapPhoneExtraLarge, IconTaxesExtraLarge, IconTipsExtraLarge, IconTrashExtraLarge, IconUnknownPaymentExtraLarge, IconUnlockedExtraLarge, IconUserGenericExtraLarge, IconVolumeExtraLarge, IconZoominExtraLarge, IconZoomoutExtraLarge]
export const IconsLarge = [IconCircleCrossLarge, IconCircleMinusLarge, IconCirclePlusLarge, IconCircleTickLarge, IconCircleTickOpenLarge, IconClockLarge, IconCompassLarge, IconDeadLarge, IconDeniedLarge, IconHappyLarge, IconHelpLarge, IconHumbleFailLarge, IconInfoLarge, IconSadLarge, IconVeryHappyLarge, IconWarningLarge, IconBarZeroOneLarge, IconBarZeroTwoLarge, IconBarZeroThreeLarge, IconBycicleLarge, IconCookingLarge, IconCutleryZeroOneLarge, IconCutleryZeroTwoLarge, IconCutleryZeroThreeLarge, IconDeliveryBagLarge, IconKitchenbellLarge, IconPrepFoodLarge, IconStopwatchLarge, IconTableLarge, IconTableNumberLarge, IconTimerLarge, IconBatteryChargingLarge, IconBatteryCriticalLarge, IconBatteryEmptyLarge, IconBatteryOneBarLarge, IconBatteryThreeBarsLarge, IconBatteryTwoBarsLarge, IconCameraLarge, IconCardReaderOneDisconnectedLarge, IconCardReaderOneLarge, IconCashDrawerLarge, IconHeadphonesLarge, IconLaptopLarge, IconMicrophoneLarge, IconMiuraDisconnectedLarge, IconMiuraLarge, IconPeripheralsLarge, IconPhoneLarge, IconReceiptPrinterLarge, IconStandardPrinterLarge, IconTabletLarge, IconUsbCableLarge, IconWifiDisabledLarge, IconWifiLarge, IconArrowDownLarge, IconArrowLeftLarge, IconArrowRightLarge, IconArrowUpLarge, IconBarDiagramLarge, IconCrossLarge, IconDownloadLarge, IconExportLarge, IconImportLarge, IconMenuLarge, IconMinusLarge, IconMoreLarge, IconPercentLarge, IconPlusLarge, IconReloadLarge, IconRevertLarge, IconSimpleArrowDownLarge, IconSimpleArrowLeftLarge, IconSimpleArrowRightLarge, IconSimpleArrowUpLarge, IconSortDownLarge, IconSortUpLarge, IconTickLarge, IconUndoLarge, IconOneTwoThreeLarge, IconBackspaceLarge, IconBankLarge, IconBarcodeLarge, IconBarcodeokLarge, IconBulletlistLarge, IconCardLarge, IconCardOverPhoneLarge, IconCashLarge, IconChatLarge, IconChipLarge, IconCloudLarge, IconCogLarge, IconCopyClipboardLarge, IconDateLarge, IconDeliveryLarge, IconDepositLarge, IconEcommerceLarge, IconEditLarge, IconEmailLarge, IconErrorLarge, IconFilterLarge, IconFundingLarge, IconGiftCardLarge, IconGridOnex1Large, IconGridTwox2Large, IconGridThreex3Large, IconHeartLarge, IconHideLarge, IconHidekeyboardLarge, IconHomeLarge, IconIdCardLarge, IconIdeaLarge, IconIdentitycardLarge, IconInventoryLarge, IconLetterLarge, IconLetterRevertLarge, IconLibraryLarge, IconLockLarge, IconMappinLarge, IconMoneyWarningLarge, IconMoneybagLarge, IconMultipaymentsLarge, IconNotificationLarge, IconOnlinePayLarge, IconOpenInNewLarge, IconOrdersLarge, IconPaymentOptionsLarge, IconPdfLarge, IconPersonTwoLarge, IconPersonThreeLarge, IconPersonFourLarge, IconPersonFiveLarge, IconPersonLarge, IconPiechartLarge, IconProductsLarge, IconPuzzleLarge, IconQrCodeLarge, IconReceiptLarge, IconRefundLarge, IconReportsLarge, IconSearchLarge, IconSendLarge, IconSettingsLarge, IconShareLarge, IconShoppingBasketLarge, IconShoppingbagLarge, IconShoppingcartLarge, IconShowLarge, IconShutdownLarge, IconStaffLarge, IconStarLarge, IconTagLarge, IconTapPhoneLarge, IconTaxesLarge, IconTipsLarge, IconTrashLarge, IconUnknownPaymentLarge, IconUnlockedLarge, IconUserGenericLarge, IconVolumeLarge, IconZoominLarge, IconZoomoutLarge]
export const IconsExtraSmall = [IconCircleCrossFilledExtraSmall, IconCircleCrossExtraSmall, IconCircleMinusExtraSmall, IconCirclePlusFilledExtraSmall, IconCirclePlusExtraSmall, IconCircleTickFilledExtraSmall, IconCircleTickOpenExtraSmall, IconCircleTickExtraSmall, IconDeniedExtraSmall, IconHelpFilledExtraSmall, IconHelpExtraSmall, IconInfoFilledExtraSmall, IconInfoExtraSmall, IconWarningFilledExtraSmall, IconWarningExtraSmall, IconBatteryChargingExtraSmall, IconBatteryCriticalExtraSmall, IconBatteryEmptyExtraSmall, IconBatteryOneBarExtraSmall, IconBatteryThreeBarsExtraSmall, IconBatteryTwoBarsExtraSmall, IconCameraExtraSmall, IconArrowDownExtraSmall, IconArrowLeftExtraSmall, IconArrowRightExtraSmall, IconArrowUpExtraSmall, IconCrossExtraSmall, IconMinusExtraSmall, IconPlusExtraSmall, IconReloadExtraSmall, IconRevertExtraSmall, IconSimpleArrowDownExtraSmall, IconSimpleArrowLeftExtraSmall, IconSimpleArrowRightExtraSmall, IconSimpleArrowUpExtraSmall, IconSortDownExtraSmall, IconSortUpExtraSmall, IconTickExtraSmall, IconUndoExtraSmall, IconCogFilledExtraSmall, IconCogExtraSmall, IconDateExtraSmall, IconEditExtraSmall, IconErrorFilledExtraSmall, IconErrorExtraSmall, IconFilterExtraSmall, IconHeartExtraSmall, IconOpenInNewExtraSmall, IconSettingsExtraSmall, IconStarExtraSmall, IconTaxesExtraSmall, IconTrashExtraSmall, IconUserGenericExtraSmall]
export const IconsSmall = [IconCircleCrossFilledSmall, IconCircleCrossSmall, IconCircleMinusSmall, IconCirclePlusFilledSmall, IconCirclePlusSmall, IconCircleTickFilledSmall, IconCircleTickOpenSmall, IconCircleTickSmall, IconClockSmall, IconCompassSmall, IconDeadSmall, IconDeniedSmall, IconHappySmall, IconHelpFilledSmall, IconHelpSmall, IconHumbleFailSmall, IconInfoFilledSmall, IconInfoSmall, IconSadSmall, IconVeryHappySmall, IconWarningFilledSmall, IconWarningSmall, IconBarZeroOneSmall, IconBarZeroTwoSmall, IconBarZeroThreeSmall, IconBycicleSmall, IconCookingSmall, IconCutleryZeroOneSmall, IconCutleryZeroTwoSmall, IconCutleryZeroThreeSmall, IconDeliveryBagSmall, IconKitchenbellSmall, IconPrepFoodSmall, IconStopwatchSmall, IconTableNumberSmall, IconTableSmall, IconTimerSmall, IconBatteryChargingSmall, IconBatteryCriticalSmall, IconBatteryEmptySmall, IconBatteryOneBarSmall, IconBatteryThreeBarsSmall, IconBatteryTwoBarsSmall, IconCameraSmall, IconCardReaderOneDisconnectedSmall, IconCardReaderOneSmall, IconCashDrawerFilledSmall, IconCashDrawerSmall, IconHeadphonesSmall, IconLaptopSmall, IconMicrophoneSmall, IconMiuraDisconnectedSmall, IconMiuraSmall, IconPeripheralsSmall, IconPhoneSmall, IconReceiptPrinterFilledSmall, IconReceiptPrinterSmall, IconStandardPrinterFilledSmall, IconStandardPrinterSmall, IconTabletSmall, IconUsbCableSmall, IconWifiDisabledSmall, IconWifiSmall, IconArrowDownSmall, IconArrowLeftSmall, IconArrowRightSmall, IconArrowUpSmall, IconBarDiagramSmall, IconCrossSmall, IconDownloadSmall, IconExportSmall, IconImportSmall, IconMenuSmall, IconMinusSmall, IconMoreSmall, IconPercentSmall, IconPlusSmall, IconReloadSmall, IconRevertSmall, IconSimpleArrowDownSmall, IconSimpleArrowLeftSmall, IconSimpleArrowRightSmall, IconSimpleArrowUpSmall, IconSortDownSmall, IconSortUpSmall, IconTickSmall, IconUndoSmall, IconOneTwoThreeFilledSmall, IconOneTwoThreeSmall, IconBackspaceFilledSmall, IconBackspaceSmall, IconBankFilledSmall, IconBankSmall, IconBarcodeFilledSmall, IconBarcodeSmall, IconBarcodeokFilledSmall, IconBarcodeokSmall, IconBulletlistFilledSmall, IconBulletlistSmall, IconCardFilledSmall, IconCardOverPhoneSmall, IconCardSmall, IconCashFilledSmall, IconCashSmall, IconChatFilledSmall, IconChatSmall, IconChipFilledSmall, IconChipSmall, IconCloudFilledSmall, IconCloudSmall, IconCogFilledSmall, IconCogSmall, IconCopyClipboardSmall, IconDateFilledSmall, IconDateSmall, IconDeliveryFilledSmall, IconDeliverySmall, IconDepositFilledSmall, IconDepositSmall, IconEcommerceFilledSmall, IconEcommerceSmall, IconEditFilledSmall, IconEditSmall, IconEmailFilledSmall, IconEmailSmall, IconErrorFilledSmall, IconErrorSmall, IconFilterSmall, IconFundingFilledSmall, IconFundingSmall, IconGiftCardSmall, IconHeartFilledSmall, IconHeartSmall, IconHideSmall, IconHidekeyboardFilledSmall, IconHidekeyboardSmall, IconHomeFilledSmall, IconHomeSmall, IconIdCardFilledSmall, IconIdCardSmall, IconIdeaFilledSmall, IconIdeaSmall, IconIdentitycardFilledSmall, IconIdentitycardSmall, IconInventorySmall, IconLetterFilledSmall, IconLetterRevertFilledSmall, IconLetterRevertSmall, IconLetterSmall, IconLibraryFilledSmall, IconLibrarySmall, IconLockFilledSmall, IconLockSmall, IconMappinFilledSmall, IconMappinSmall, IconMoneyWarningSmall, IconMoneybagFilledSmall, IconMoneybagSmall, IconMultipaymentsSmall, IconNotificationFilledSmall, IconNotificationSmall, IconOnlinePaySmall, IconOpenInNewSmall, IconOrdersSmall, IconPaymentOptionsSmall, IconPdfFilledSmall, IconPdfSmall, IconPersonTwoSmall, IconPersonThreeSmall, IconPersonFourSmall, IconPersonFiveSmall, IconPersonFilledSmall, IconPersonSmall, IconPiechartFilledSmall, IconPiechartSmall, IconProductsFilledSmall, IconProductsSmall, IconPuzzleFilledSmall, IconPuzzleSmall, IconQrCodeSmall, IconReceiptFilledSmall, IconReceiptSmall, IconRefundSmall, IconReorderSmall, IconReportsFilledSmall, IconReportsSmall, IconSearchFilledSmall, IconSearchSmall, IconSendFilledSmall, IconSendSmall, IconSettingsFilledSmall, IconSettingsSmall, IconShareFilledSmall, IconShareSmall, IconShoppingBasketFilledSmall, IconShoppingBasketSmall, IconShoppingbagFilledSmall, IconShoppingbagSmall, IconShoppingcartFilledSmall, IconShoppingcartSmall, IconShowSmall, IconShutdownFilledSmall, IconShutdownSmall, IconStaffFilledSmall, IconStaffSmall, IconStarFilledSmall, IconStarSmall, IconTagFilledSmall, IconTagSmall, IconTapPhoneSmall, IconTaxesSmall, IconTipsSmall, IconTrashFilledSmall, IconTrashSmall, IconUnknownPaymentSmall, IconUnlockedFilledSmall, IconUnlockedSmall, IconUserGenericSmall, IconVolumeFilledSmall, IconVolumeSmall, IconZoominFilledSmall, IconZoominSmall, IconZoomoutFilledSmall, IconZoomoutSmall]
export const IconsMedium = [IconCircleCrossFilledMedium, IconCircleCrossMedium, IconCircleMinusMedium, IconCirclePlusFilledMedium, IconCirclePlusMedium, IconCircleTickFilledMedium, IconCircleTickMedium, IconCircleTickOpenMedium, IconClockMedium, IconCompassMedium, IconDeadMedium, IconDeniedMedium, IconHappyMedium, IconHelpFilledMedium, IconHelpMedium, IconHumbleFailMedium, IconInfoFilledMedium, IconInfoMedium, IconSadMedium, IconVeryHappyMedium, IconWarningFilledMedium, IconWarningMedium, IconBarZeroOneMedium, IconBarZeroTwoMedium, IconBarZeroThreeMedium, IconBycicleMedium, IconCookingMedium, IconCutleryZeroOneMedium, IconCutleryZeroTwoMedium, IconCutleryZeroThreeMedium, IconDeliveryBagMedium, IconKitchenbellMedium, IconPrepFoodMedium, IconStopwatchMedium, IconTableMedium, IconTableNumberMedium, IconTimerMedium, IconBatteryChargingMedium, IconBatteryCriticalMedium, IconBatteryEmptyMedium, IconBatteryOneBarMedium, IconBatteryThreeBarsMedium, IconBatteryTwoBarsMedium, IconCameraMedium, IconCardReaderOneDisconnectedMedium, IconCardReaderOneMedium, IconCashDrawerFilledMedium, IconCashDrawerMedium, IconHeadphonesMedium, IconLaptopMedium, IconMicrophoneMedium, IconMiuraDisconnectedMedium, IconMiuraMedium, IconPeripheralsMedium, IconPhoneMedium, IconPrinterBatteryOnebarMedium, IconPrinterBatteryTwobarsMedium, IconPrinterBatteryThreebarsMedium, IconPrinterBatteryChargingMedium, IconPrinterBatteryCriticalMedium, IconReceiptPrinterFilledMedium, IconReceiptPrinterMedium, IconStandardPrinterFilledMedium, IconStandardPrinterMedium, IconTabletMedium, IconTerminalDockMedium, IconTerminalMedium, IconUsbCableMedium, IconWifiDisabledMedium, IconWifiMedium, IconAlipayMedium, IconAmexMedium, IconAndroidMedium, IconAndroidPayMedium, IconAppleMedium, IconApplePayMedium, IconBluetoothMedium, IconCarnetMedium, IconCartebleueMedium, IconContactlessMedium, IconDinersMedium, IconDiscoverMedium, IconEcMedium, IconElectronMedium, IconEloMedium, IconElvMedium, IconGpayMedium, IconHiperMedium, IconHipercardMedium, IconJcbMedium, IconKlarnaMedium, IconMaestroMedium, IconMastercardFullMedium, IconMastercardMedium, IconMobilepayMedium, IconNfcMedium, IconPaypalMedium, IconSamsungPayMedium, IconSkatterverketMedium, IconSwishMedium, IconUnionpayMedium, IconVenmoMedium, IconVippsMedium, IconVisaMedium, IconVpayMedium, IconWechatMedium, IconZettleIconMedium, IconZettleMedium, IconZettleNegativeMedium, IconZettleZMedium, IconArrowDownMedium, IconArrowLeftMedium, IconArrowRightMedium, IconArrowUpMedium, IconBarDiagramMedium, IconCrossMedium, IconDownloadMedium, IconExportMedium, IconImportMedium, IconMenuMedium, IconMinusMedium, IconMoreMedium, IconPercentMedium, IconPlusMedium, IconReloadMedium, IconRevertMedium, IconSimpleArrowDownMedium, IconSimpleArrowLeftMedium, IconSimpleArrowRightMedium, IconSimpleArrowUpMedium, IconSortDownMedium, IconSortUpMedium, IconTickMedium, IconUndoMedium, IconOneTwoThreeFilledMedium, IconOneTwoThreeMedium, IconAccessibilityMedium, IconAppsSystemUpdateMedium, IconBackspaceFilledMedium, IconBackspaceMedium, IconBankFilledMedium, IconBankMedium, IconBarcodeFilledMedium, IconBarcodeMedium, IconBarcodeokFilledMedium, IconBarcodeokMedium, IconBulletlistFilledMedium, IconBulletlistMedium, IconCardFilledMedium, IconCardMedium, IconCardOverPhoneMedium, IconCashFilledMedium, IconCashMedium, IconChatFilledMedium, IconChatMedium, IconChipFilledMedium, IconChipMedium, IconCloudFilledMedium, IconCloudMedium, IconCogFilledMedium, IconCogMedium, IconCopyClipboardMedium, IconDateFilledMedium, IconDateMedium, IconDeliveryFilledMedium, IconDeliveryMedium, IconDepositFilledMedium, IconDepositMedium, IconEcommerceFilledMedium, IconEcommerceMedium, IconEditFilledMedium, IconEditMedium, IconEmailFilledMedium, IconEmailMedium, IconErrorFilledMedium, IconErrorMedium, IconFilterMedium, IconFundingFilledMedium, IconFundingMedium, IconGiftCardMedium, IconHeartFilledMedium, IconHeartMedium, IconHideMedium, IconHidekeyboardFilledMedium, IconHidekeyboardMedium, IconHomeFilledMedium, IconHomeMedium, IconIdCardFilledMedium, IconIdCardMedium, IconIdeaFilledMedium, IconIdeaMedium, IconIdentitycardFilledMedium, IconIdentitycardMedium, IconInventoryMedium, IconLetterFilledMedium, IconLetterMedium, IconLetterRevertFilledMedium, IconLetterRevertMedium, IconLibraryFilledMedium, IconLibraryMedium, IconLockFilledMedium, IconLockMedium, IconMappinFilledMedium, IconMappinMedium, IconMoneyWarningMedium, IconMoneybagFilledMedium, IconMoneybagMedium, IconMountingMedium, IconMultipaymentsMedium, IconNavigationMedium, IconNotificationFilledMedium, IconNotificationMedium, IconOnlinePayMedium, IconOpenInNewMedium, IconOrdersMedium, IconPaymentOptionsMedium, IconPdfFilledMedium, IconPdfMedium, IconPersonTwoMedium, IconPersonThreeMedium, IconPersonFourMedium, IconPersonFiveMedium, IconPersonFilledMedium, IconPersonMedium, IconPiechartFilledMedium, IconPiechartMedium, IconPrinterPaperRollMedium, IconProductsFilledMedium, IconProductsMedium, IconPuzzleFilledMedium, IconPuzzleMedium, IconQrCodeMedium, IconReceiptFilledMedium, IconReceiptMedium, IconRefundMedium, IconReorderMedium, IconReportsFilledMedium, IconReportsMedium, IconSearchFilledMedium, IconSearchMedium, IconSendFilledMedium, IconSendMedium, IconSettingsFilledMedium, IconSettingsMedium, IconShareFilledMedium, IconShareMedium, IconShoppingBasketFilledMedium, IconShoppingBasketMedium, IconShoppingbagFilledMedium, IconShoppingbagMedium, IconShoppingcartFilledMedium, IconShoppingcartMedium, IconShowMedium, IconShutdownFilledMedium, IconShutdownMedium, IconStaffFilledMedium, IconStaffMedium, IconStarFilledMedium, IconStarMedium, IconTagFilledMedium, IconTagMedium, IconTapPhoneMedium, IconTaxesMedium, IconTipsMedium, IconTrashFilledMedium, IconTrashMedium, IconUnknownPaymentMedium, IconUnlockedFilledMedium, IconUnlockedMedium, IconUserGenericMedium, IconVolumeFilledMedium, IconVolumeMedium, IconZoominFilledMedium, IconZoominMedium, IconZoomoutFilledMedium, IconZoomoutMedium]
